<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading_i">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="bmTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab"
              aria-controls="tab1" aria-selected="true" @click="onClickTab('1')">
              {{ $t("content.overview") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="tab3-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3" type="button" role="tab"
              aria-controls="tab3" aria-selected="false" @click="onClickTab('3')">
              {{ $t("content.detail") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="tab2-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab2" aria-selected="false" @click="onClickTab('2')">
              {{ $t("content.repredeint") }}
            </button>
          </li>

        </ul>


        <div id="bmTabContent" class="tab-content">
          <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="card h-100 mt-3">
                  <div class="card-header mb-0">
                    <h5>{{ $t("content.gdashboard") }} 
                      <span class="text-danger">
                        ({{ $t("content.up_d") }} : {{ res_time }})
                      </span>
                    </h5>
                  </div>
                  <div class="card-body pt-0">
                    <div class="row">
                      <div class="col-6 text-center">
                        <h5 class="mt-4 mb-0">
                          {{ $t("content.numberactive") }}
                        </h5>
                        <div>
                          <h5 class="mb-0 text-info">
                            <b>
                              <span v-if="loading">
                                {{ formatNumberString(dataInfo.numOfActiveWorkCase) }}
                              </span>
                              <span v-else>
                                0
                              </span>
                            </b>
                          </h5>
                        </div>
                      </div>
                      <div class="col-6 text-center">
                        <h5 class="mt-4 mb-0">
                          <span v-if="dataInfo.numOfPostponeWorkCase > 0" @click="goToRpDefer()"
                            style="text-decoration:underline;cursor: pointer">
                            {{ $t("content.numberpostpone") }}
                          </span>
                          <span v-else>
                            {{ $t("content.numberpostpone") }}
                          </span>
                        </h5>
                        <div>
                          <h5 class="mb-0 text-info">
                            <b>
                              <span v-if="loading">
                                {{ formatNumberString(dataInfo.numOfPostponeWorkCase) }}
                              </span>
                              <span v-else>
                                0
                              </span>
                            </b>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <pre></pre>
                    <div class="row">
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.sdate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.edate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-2 me-3">
                        <span class="form-label m-0"></span>
                        <div class="d-inline-block mx-4">
                          <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                            @click="loadDataInfoApi" :disabled="monthDiff() || start_date > end_date">
                            <i class="material-icons material-symbols-outlined">search</i>
                            {{ search }}
                          </material-button>
                          <material-button data-bs-toggle="modal" data-bs-target="#detailUserWorkModal"
                            id="userWorkModalShow" v-show="false">
                          </material-button>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4 text-center">
                        <h5 class="mt-4 mb-0">
                          <b> {{ $t("content.amnenter") }} </b>
                        </h5>
                        <div>
                          <h2 class="mb-0 text-info">
                            <b>
                              <span v-if="loading">
                                {{ formatNumberString(dataInfo.numOfCustomer) }}
                              </span>
                              <span v-else>
                                0
                              </span>
                            </b>
                          </h2>
                        </div>
                      </div>

                      <div class="col-2 text-center">
                        <h5 class="mt-4 mb-0">
                          <b> {{ $t("content.numOfCancel") }} </b>
                        </h5>
                        <div>
                          <h2 class="mb-0 text-info">
                            <b style="color:red;">
                              <span v-if="loading">
                                {{ formatNumberString(dataInfo.numOfCancelTicket) }}
                              </span>
                              <span v-else>
                                0
                              </span>
                            </b>
                          </h2>
                        </div>
                      </div>

                      <div class="col-3 text-center">
                        <h5 class="mt-4 mb-0">
                          <b> {{ $t("content.numOfTerminate") }} </b>
                        </h5>
                        <div>
                          <h2 class="mb-0 text-info">
                            <b style="color:orange;">
                              <span v-if="loading">
                                {{ formatNumberString(dataInfo.numOfTerminate) }}
                              </span>
                              <span v-else>
                                0
                              </span>
                            </b>
                          </h2>
                        </div>
                      </div>

                      <div class="col-3 text-center">
                        <h5 class="mt-4 mb-0">
                          <b>
                            {{ $t("content.editafcom") }}
                          </b>
                        </h5>
                        <div>
                          <h2 class="mb-0 text-info">
                            <b style="color:#656A60;">
                              <span v-if="loading">
                                {{ formatNumberString(dataInfo.numOfEditAfterComplete)
                                }}
                              </span>
                              <span v-else>
                                0
                              </span>
                            </b>
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-center">
                        <h5 class="mt-4 mb-0">
                          {{ $t("content.numberotp") }}
                        </h5>
                        <div>
                          <h5 class="mb-0 text-info">
                            <b>
                              <span v-if="loading">
                                {{ formatNumberString(dataInfo.numOfOtp) }}
                              </span>
                              <span v-else>
                                0
                              </span>
                            </b>
                          </h5>
                        </div>
                      </div>
                      <div class="col-6 text-center">
                        <h5 class="mt-4 mb-0">
                          {{ $t("content.numberotpmi") }}
                        </h5>
                        <div>
                          <h5 class="mb-0 text-info">
                            <b>
                              <span v-if="loading">
                                {{ formatNumberString(dataInfo.numOfOtpMigration) }}
                              </span>
                              <span v-else>
                                0
                              </span>
                            </b>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-lg-12 mb-2">
                <div class="card h-100 mt-2">
                  <div class="h-100 mt-2">
                    <div class="p-3 pb-0 card-header">
                      <div class="d-flex justify-content-between">
                        <h5 class="mb-0">
                          <b>{{ $t("content.workProcess") }}
                          </b>
                        </h5>
                      </div>
                    </div>

                    <div class="card-body pt-0">
                      <div class="row">
                        <div class="col-2 text-center">
                          <h5 class="mt-4 mb-0">
                            <span v-if="list_q01.length > 0" @click="viewUserWorkDetail('Q01')"
                              style="text-decoration:underline;cursor: pointer">
                              {{ $t("content.workQ01") }}
                            </span>
                            <span v-else>
                              {{ $t("content.workQ01") }}
                            </span>
                          </h5>
                          <div>
                            <h5 class="mb-0 text-info">
                              <b>
                                <span v-if="loading">
                                  {{ formatNumberString(num_q01) }}
                                </span>
                                <span v-else>
                                  0
                                </span>
                              </b>
                            </h5>
                          </div>
                        </div>

                        <div class="col-3 text-center">
                          <h5 class="mt-4 mb-0">
                            <span v-if="list_q02.length > 0" @click="viewUserWorkDetail('Q02')"
                              style="text-decoration:underline;cursor: pointer">
                              {{ $t("content.workQ02") }}
                            </span>
                            <span v-else>
                              {{ $t("content.workQ02") }}
                            </span>
                          </h5>
                          <div>
                            <h5 class="mb-0 text-info">
                              <b>
                                <span v-if="loading">
                                  {{ formatNumberString(num_q02) }}
                                </span>
                                <span v-else>
                                  0
                                </span>
                              </b>
                            </h5>
                          </div>
                        </div>

                        <div class="col-3 text-center">
                          <h5 class="mt-4 mb-0">
                            <span v-if="list_q03.length > 0" @click="viewUserWorkDetail('Q03')"
                              style="text-decoration:underline;cursor: pointer">
                              {{ $t("content.workQ03") }}
                            </span>
                            <span v-else>
                              {{ $t("content.workQ03") }}</span>
                          </h5>
                          <div>
                            <h5 class="mb-0 text-info">
                              <b>
                                <span v-if="loading">
                                  {{ formatNumberString(num_q03) }}
                                </span>
                                <span v-else>
                                  0
                                </span>
                              </b>
                            </h5>
                          </div>
                        </div>

                        <div class="col-2 text-center">
                          <h5 class="mt-4 mb-0">
                            <span v-if="list_q04.length > 0" @click="viewUserWorkDetail('Q04')"
                              style="text-decoration:underline;cursor: pointer">
                              {{ $t("content.workQ04") }}
                            </span>
                            <span v-else>
                              {{ $t("content.workQ04") }}
                            </span>
                          </h5>
                          <div>
                            <h5 class="mb-0 text-info">
                              <b>
                                <span v-if="loading">
                                  {{ formatNumberString(num_q04) }}
                                </span>
                                <span v-else>
                                  0
                                </span>
                              </b>
                            </h5>
                          </div>
                        </div>

                        <div class="col-2 text-center">
                          <h5 class="mt-4 mb-0">
                            <span v-if="list_pay.length > 0" @click="viewUserWorkDetail('QPAY')"
                              style="text-decoration:underline;cursor: pointer">
                              {{ $t("content.workQpay") }}
                            </span>
                            <span v-else>
                              {{ $t("content.workQpay") }}
                            </span>
                          </h5>
                          <div>
                            <h5 class="mb-0 text-info">
                              <b>
                                <span v-if="loading">
                                  {{ formatNumberString(num_pay) }}
                                </span>
                                <span v-else>
                                  0
                                </span>
                              </b>
                            </h5>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="col-lg-12 mb-2">
                <div class="card h-100 mt-2">
                  <div class="row mb-2">
                    <div class="col-lg-12 mb-2">
                      <div class="h-100 mt-2">
                        <div class="p-3 pb-0 card-header">
                          <div class="col-8 d-flex justify-content-start">
                            <div class="row">            
                                <div class="me-2">
                                  <div class="d-inline-block mx-0">
                                     <span class="form-label m-0"><h5 class="mb-0"><b>{{ $t("content.oldsystemsinfo") }}</b></h5>
                                  </span> 
                                  </div>
                                  <div class="d-inline-block mx-4">
                                    <material-checkbox id="asGraph" v-model="viewGraph"  :checked="viewGraph" @change="changeViewGraph" name="rdoGraph">
                                     <b>Graph</b>
                                    </material-checkbox>
                                  </div>

                                  <div class="d-inline-block me-4">
                                    <material-checkbox id="asInfo" v-model="viewInfo" :checked="viewInfo" @change="changeViewInfo" name="rdoInfo">
                                     <b>Data</b>
                                    </material-checkbox>
                                  </div>
                               </div>
                            </div>  
                          </div>
                          <div class="col-4 d-flex justify-content-end align-items-center"></div>
                          </div>

                        <div class="card-body pt-0">
                          <div class="row" v-if="viewInfo">
                             <div class="col-2">
                              <h5 class="mt-4 mb-0 text-start">
                                {{ $t("content.pawntktotal") }} :&nbsp;
                                <span style="color: red;">
                                  <b>{{ formatNumberString(sum_pawncase) }}</b>
                                </span>
                              </h5>
                            </div>

                            <div class="col-4">
                              <h5 class="mt-4 mb-0 text-start">
                                {{ $t("content.pawntotal") }} ({{
                                  $t("content.newtktotal")
                                }}) :&nbsp;
                                <span style="color: red;">
                                  <b>{{ formatDecimalString(sum_pawnvalue) }}</b>
                                </span>
                              </h5>
                            </div>

                            <div class="col-2">
                              <h5 class="mt-4 mb-0 text-start">
                                {{ $t("content.redeemtktotal") }} :&nbsp;
                                <span style="color: green;">
                                  <b>{{ formatNumberString(sum_redeemcase) }}</b>
                                </span>
                              </h5>
                            </div>

                            <div class="col-4">
                              <h5 class="mt-4 mb-0 text-start">
                                {{ $t("content.redeemtotal") }} ({{
                                  $t("content.oldtktotal")
                                }}) :&nbsp;
                                <span style="color: green;">
                                  <b>{{ formatDecimalString(sum_redeemvalue) }}</b>
                                </span>
                              </h5>
                            </div>
                          </div>

                          <div class="row" v-if="viewGraph">
                          
                            <div class="dashboard-container">
                              <div 
                                v-for="(item, index) in stats" 
                                :key="index" 
                                :class="['card-d', item.type]"
                              >
                                <!-- Icon Section -->
                                <div class="icon-section">
                                  <i :class="item.icon"></i>
                                </div>

                                <!-- Data Section -->
                                <div class="data-section">
                                  <!-- หัวข้อ: ถ้าเป็น net-cash จะแสดง (เพิ่มขึ้น/ลดลง) ต่อท้าย -->
                                  <div class="text-start label">
                                    {{ item.label }} 
                                    <span :class="isPositiveNetCash(item) ? 'text-success' : 'text-danger'">
                                      {{ getStatusText(item) }}
                                    </span>
                                  </div>

                                  <!-- 2. ส่วนจำนวนเงิน: เปลี่ยนสีทั้งชุดตัวเลขและหน่วยบาท (ถ้าเป็น 0 จะไม่ติด Class สี) -->
                                  <div class="value" :class="{
                                      'text-success': item.type === 'net-cash' && item.value > 0,
                                      'text-danger': item.type === 'net-cash' && item.value < 0
                                    }"> 
                                    {{ item.value.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                                    <span class="unit">บาท</span>
                                  </div>

                                  <!-- 3. ส่วนสต๊อกสุทธิ: เปลี่ยนสีทั้งตัวเลขและคำว่า "รายการ" -->
                                  <div v-if="item.subPrefix" class="sub-text">
                                    {{ item.subPrefix }}
                                    <span  :class="{
                                          'text-success': item.type === 'net-cash' && parseFloat(item.subText) > 0,
                                          'text-danger': item.type === 'net-cash' && parseFloat(item.subText) < 0
                                        }">
                                      {{ item.subText }} {{ item.subUnit }} <!-- ใส่ subUnit ไว้ใน span สีเขียว -->
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="viewInfo">
                    <div class="col-lg-7 mb-2">
                      <div class="h-100 mt-2">
                        <div class="p-3 pb-0 card-header">
                          <div class="d-flex justify-content-between">
                            <h5 class="mb-0">
                              <b> 
                              <!-- ปกติ จำนำ,ต่อดอก,เพิ่มต้น,ลดต้น,ไถ่ถอน -->  
                              <span v-if="Number(dataInfo.numOfPawn) +
                                    Number(dataInfo.numOfInterest) +
                                    Number(dataInfo.numOfInc) +
                                    Number(dataInfo.numOfDec) +
                                    Number(dataInfo.numOfRedeem) > 0" @click="goToHistory(1)"
                                style="text-decoration:underline;cursor: pointer">
                                {{ $t("content.ovrtransnor") }}
                              </span>
                              <span v-else>
                                {{ $t("content.ovrtransnor") }}
                              </span>
                                 :&nbsp;
                                <span class="mb-0 text-info" v-if="loading">
                                  {{ formatNumberString(Number(dataInfo.numOfPawn) +
                                    Number(dataInfo.numOfInterest) +
                                    Number(dataInfo.numOfInc) +
                                    Number(dataInfo.numOfDec) +
                                    Number(dataInfo.numOfRedeem)) }}
                                </span>
                                <span v-else>
                                  0
                                </span>
                              </b>
                            </h5>
                          </div>
                        </div>
                        <div class="p-3 mt-4 card-body">
                          <table class="table table-sm table-borderless">
                            <tbody>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i :class="legendTimes[0].bg"></i>
                                    <span class="text-md text-dark">
                                    <!-- ปกติ จำนำ -->
                                    <span v-if="Number(dataInfo.numOfPawn) > 0" @click="goToHistory(3)"
                                      style="text-decoration:underline;cursor: pointer">
                                      {{ $t("content.actpawn1") }}
                                    </span>
                                    <span v-else>
                                      {{ $t("content.actpawn1") }}
                                    </span>
                                      <span class="mb-0 text-info">
                                        ({{
                                          formatNumberString(dataInfo.numOfPawn)
                                        }})
                                      </span>
                                    </span>
                                  </span>
                                </td>
                                <td colspan="3" class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.valticket") }}&nbsp;
                                    {{ formatDecimalString(dataInfo.pawnValue)
                                    }}</span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i :class="legendTimes[1].bg"></i>
                                    <span class="text-md text-dark">
                                    <!-- ปกติ ต่อดอก -->
                                    <span v-if="Number(dataInfo.numOfInterest) > 0" @click="goToHistory(4)"
                                      style="text-decoration:underline;cursor: pointer">
                                      {{ $t("content.actpawn2") }}
                                    </span>
                                    <span v-else>
                                      {{ $t("content.actpawn2") }}
                                    </span>
                                      <span class="mb-0 text-info">
                                        ({{
                                          formatNumberString(dataInfo.numOfInterest)
                                        }})
                                      </span>
                                    </span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.valticket") }}&nbsp;
                                    {{
                                      formatDecimalString(dataInfo.interestPawnValue)
                                    }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.amninterest") }}&nbsp;
                                    {{ formatDecimalString(dataInfo.interestAmount)
                                    }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i :class="legendTimes[2].bg"></i>
                                    <span class="text-md text-dark">
                                      <!-- ปกติ เพิ่มต้น -->
                                      <span v-if="Number(dataInfo.numOfInc) > 0" @click="goToHistory(5)"
                                      style="text-decoration:underline;cursor: pointer">
                                      {{ $t("content.actpawn3") }}
                                      </span>
                                      <span v-else>
                                        {{ $t("content.actpawn3") }}
                                      </span>
                                      <span class="mb-0 text-info">
                                        ({{
                                          formatNumberString(dataInfo.numOfInc)
                                        }})
                                      </span>
                                    </span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.valticket") }}&nbsp;
                                    {{ formatDecimalString(dataInfo.incPawnValue) }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.amninterest") }}&nbsp;
                                    {{
                                      formatDecimalString(dataInfo.incInterestAmount)
                                    }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.amncashdrawerdiff") }}&nbsp;
                                    {{ formatDecimalString(dataInfo.incDiff) }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i :class="legendTimes[3].bg"></i>
                                      <span class="text-md text-dark">
                                      <!-- ปกติ ลดต้น -->
                                      <span v-if="Number(dataInfo.numOfDec) > 0" @click="goToHistory(6)"
                                      style="text-decoration:underline;cursor: pointer">
                                      {{ $t("content.actpawn4") }}
                                      </span>
                                      <span v-else>
                                        {{ $t("content.actpawn4") }}
                                      </span>
                                      <span class="mb-0 text-info">
                                        ({{
                                          formatNumberString(dataInfo.numOfDec)
                                        }})
                                      </span>
                                    </span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.valticket") }}&nbsp;
                                    {{ formatDecimalString(dataInfo.decPawnValue) }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.amninterest") }}&nbsp;
                                    {{
                                      formatDecimalString(dataInfo.decInterestAmount)
                                    }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.amncashdrawerdiff") }}&nbsp;
                                    {{ formatDecimalString(dataInfo.decDiff) }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i :class="legendTimes[4].bg"></i>
                                    <span class="text-md text-dark">
                                      <!-- ปกติ ไถ่ถอน -->
                                      <span v-if="Number(dataInfo.numOfRedeem) > 0" @click="goToHistory(7)"
                                      style="text-decoration:underline;cursor: pointer">
                                      {{ $t("content.actpawn5") }}
                                      </span>
                                      <span v-else>
                                        {{ $t("content.actpawn5") }}
                                      </span>
                                      <span class="mb-0 text-info">
                                        ({{
                                          formatNumberString(dataInfo.numOfRedeem)
                                        }})
                                      </span>
                                    </span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.valticket") }}&nbsp;
                                    {{ formatDecimalString(dataInfo.redeemPawnValue)
                                    }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.amninterest") }}&nbsp;
                                    {{
                                      formatDecimalString(dataInfo.redeemInterestAmount)
                                    }}
                                  </span>
                                </td>
                              </tr>
                              <pre></pre>
                              <tr>
                                <td colspan="2" class="fs-14 text-bold">
                                  <span class="text-md text-dark">
                                    <!-- ปกติ จำนำ,เพิ่มต้น -->
                                     <span v-if="Number(sum_painvalue) > 0" @click="goToHistory(11)"
                                      style="text-decoration:underline;cursor: pointer">
                                      {{ $t("content.actpawn1") }},{{
                                      $t("content.actpawn3") }}
                                      </span>
                                      <span v-else>
                                       {{ $t("content.actpawn1") }},{{
                                      $t("content.actpawn3") }}
                                      </span> :&nbsp;
                                    <span style="color: red;">
                                      {{ formatDecimalString(sum_painvalue) }}
                                    </span> </span>
                                </td>
                                <td colspan="2" class="fs-14 text-bold">
                                  <span class="text-md text-dark">  
                                    <!-- ปกติ ต่อดอก,ลดต้น,ไถ่ถอน -->
                                    <span v-if="Number(sum_inderevalue) > 0" @click="goToHistory(12)"
                                      style="text-decoration:underline;cursor: pointer">
                                      {{ $t("content.actpawn2") }},{{
                                      $t("content.actpawn4") }},{{
                                      $t("content.actpawn5") }}
                                      </span>
                                      <span v-else>
                                      {{ $t("content.actpawn2") }},{{
                                      $t("content.actpawn4") }},{{
                                      $t("content.actpawn5") }}
                                      </span> :&nbsp;
                                    <span style="color: green;">
                                      {{ formatDecimalString(sum_inderevalue) }}
                                    </span>

                                  </span>
                                </td>
                              </tr>
                              <pre></pre>
                              <tr>
                                <td colspan="2" class="fs-14 text-bold">
                                  <span class="text-md text-dark">
                                    {{ $t("content.sumvalticket") }} :&nbsp;
                                    <span style="color: blue;">
                                      {{ formatDecimalString(sum_pvalue) }}
                                    </span>
                                  </span>
                                </td>
                                <td colspan="2" class="fs-14 text-bold">
                                  <span class="text-md text-dark">
                                    <span v-if="sum_intvalue > 0" @click="goToRpProfit()"
                                      style="text-decoration:underline;cursor: pointer">
                                      {{ $t("content.sumintticket") }}
                                    </span>
                                    <span v-else>
                                     {{ $t("content.sumintticket") }}
                                    </span> : &nbsp;
                                    <span style="color: green;">
                                      {{ formatDecimalString(sum_intvalue) }}
                                    </span>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5 mb-4">
                      <div class="h-100 mt-3">
                        <div class="p-3 pb-0 card-header">
                          <div class="d-flex justify-content-between">
                            <h5 class="mb-0">
                              <b>
                              <!-- ย้ายระบบ ต่อดอก,เพิ่มต้น,ลดต้น -->
                              <span v-if="Number(dataInfo.numOfInterestMigration) +
                                  Number(dataInfo.numOfIncMigration) +
                                  Number(dataInfo.numOfDecMigration) > 0" @click="goToHistory(2)"
                                style="text-decoration:underline;cursor: pointer">
                                {{ $t("content.ovrtransmig") }}
                              </span>
                              <span v-else>
                                {{ $t("content.ovrtransmig") }}
                              </span> :&nbsp;
                                <span class="mb-0 text-info" v-if="loading">
                                  {{
                                    formatNumberString(Number(dataInfo.numOfInterestMigration)
                                      +
                                      Number(dataInfo.numOfIncMigration) +
                                      Number(dataInfo.numOfDecMigration)) }}
                                </span>
                                <span v-else>
                                  0
                                </span>
                              </b>
                            </h5>

                          </div>
                        </div>
                        <div class="p-3 mt-4 card-body">
                          <table class="table table-sm table-borderless">
                            <tbody>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i :class="legendTimes[1].bg"></i>
                                    <span class="text-md text-dark">
                                      <!-- ย้ายระบบ ต่อดอก -->
                                      <span v-if="Number(dataInfo.numOfInterestMigration) > 0" @click="goToHistory(8)"
                                      style="text-decoration:underline;cursor: pointer">
                                       {{$t("content.actpawn2") }}
                                      </span>
                                      <span v-else>
                                         {{$t("content.actpawn2") }}
                                      </span> ({{$t("content.transmig")}})
                                      <span class="mb-0 text-info">
                                        ({{
                                          formatNumberString(dataInfo.numOfInterestMigration)
                                        }})
                                      </span>
                                    </span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.valticket") }}&nbsp;
                                    {{
                                      formatDecimalString(dataInfo.interestPawnValueMigration)
                                    }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i :class="legendTimes[2].bg"></i>
                                    <span class="text-md text-dark">
                                      <!-- ย้ายระบบ เพิ่มต้น -->
                                      <span v-if="Number(dataInfo.numOfIncMigration) > 0" @click="goToHistory(9)"
                                        style="text-decoration:underline;cursor: pointer">
                                        {{$t("content.actpawn3") }}
                                      </span>
                                      <span v-else>
                                        {{$t("content.actpawn3") }}
                                      </span>  ({{$t("content.transmig")}})
                                      <span class="mb-0 text-info">
                                        ({{
                                          formatNumberString(dataInfo.numOfIncMigration)
                                        }})
                                      </span>
                                    </span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.valticket") }}&nbsp;
                                    {{
                                      formatDecimalString(dataInfo.incPawnValueMigration)
                                    }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i :class="legendTimes[3].bg"></i>
                                    <span class="text-md text-dark">
                                      <!-- ย้ายระบบ ลดต้น -->
                                      <span v-if="Number(dataInfo.numOfDecMigration) > 0" @click="goToHistory(10)"
                                        style="text-decoration:underline;cursor: pointer">
                                        {{$t("content.actpawn4") }} 
                                      </span>
                                      <span v-else>
                                        {{$t("content.actpawn4") }}
                                      </span> ({{$t("content.transmig")}})
                                      <span class="mb-0 text-info">
                                        ({{
                                          formatNumberString(dataInfo.numOfDecMigration)
                                        }})
                                      </span>
                                    </span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.valticket") }}&nbsp;
                                    {{
                                      formatDecimalString(dataInfo.decPawnValueMigration)
                                    }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i></i>
                                    <span class="text-md text-dark"></span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"></span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-start" width=15>
                                  <span class="badge badge-md badge-dot me-4 d-block text-start">
                                    <i></i>
                                    <span class="text-md text-dark"></span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  <span class="text-md text-dark"> </span>
                                </td>
                              </tr>
                              <pre></pre>
                              <tr>
                                <td colspan="2" class="fs-14 text-bold">
                                  <span class="text-md text-dark"> {{
                                    $t("content.sumvalticket") }} :&nbsp;
                                    <span style="color: red;">
                                      {{ formatDecimalString(sum_mvalue) }}
                                    </span>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                       </div>
                    </div>
                  </div>


                  <div class="row" v-if="viewGraph">
                    <div class="container-fluid">
                      <!-- justify-content-center ช่วยให้ถ้ามี 3 อัน มันจะอยู่กลางหน้าพอดี -->
                      <div class="row justify-content-center">
                        <!-- Card ชุดที่ 1 (ยอดตั๋วจํานำ) -->
                        <div class="col-lg-4 col-md-6 mb-4">
                          <div class="bg-white p-3 rounded-xl flex flex-col items-center">
                            <!-- Header ส่วนยอดรวม -->
                            <h5 class="text-[11px] font-bold text-gray-600 mb-2">
                              ยอดตั๋วจํานำ : 
                              <span class="text-info"><b>
                                {{ formatDecimalString(Number(sum_mvalue)+Number(dataInfo.pawnValue)+Number(dataInfo.interestPawnValue)+Number(dataInfo.incPawnValue)+Number(dataInfo.decPawnValue))}} บาท
                              </b></span>
                            </h5>
                            <pre></pre>

                            <!-- Pie Chart กึ่งกลาง -->
                            <div class="h-24 w-24 mb-4">
                              <Pie :data="pawnData" :options="chartOptions" :plugins="[ChartDataLabels]" />
                            </div>

                            <!-- ส่วนของตารางที่ปรับใหม่ -->
                            <div class="w-full">
                              <!-- เพิ่ม mx-auto เพื่อจัดตารางให้อยู่กลางพื้นที่ -->
                              <table class="table table-sm table-borderless mx-auto w-auto mb-0">
                                <tbody class="text-[11px]"> <!-- คุมขนาดตัวอักษรที่นี่ -->
                                  <tr>
                                    <td class="py-1 px-2 text-start">
                                      <span class="flex items-center gap-2">
                                        <span>🔵</span>
                                        <span class="text-dark">{{ $t("content.actpawn1") }}</span>
                                      </span>
                                    </td>
                                    <td class="py-1 px-2 text-end font-bold">
                                      <span class="text-dark">
                                        {{ formatDecimalString(Number(sum_mvalue)+Number(dataInfo.pawnValue))}} บาท
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="py-1 px-2 text-start">
                                      <span class="flex items-center gap-2">
                                        <span>🟠</span>
                                        <span class="text-dark">{{ $t("content.actpawn2") }}</span>
                                      </span>
                                    </td>
                                    <td class="py-1 px-2 text-end font-bold">
                                      <span class="text-dark">
                                        {{ formatDecimalString(Number(dataInfo.interestPawnValue))}} บาท
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="py-1 px-2 text-start">
                                      <span class="flex items-center gap-2">
                                        <span>🟢</span>
                                        <span class="text-dark">{{ $t("content.actpawn3") }}</span>
                                      </span>
                                    </td>
                                    <td class="py-1 px-2 text-end font-bold">
                                      <span class="text-dark">
                                        {{ formatDecimalString(Number(dataInfo.incPawnValue))}} บาท
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="py-1 px-2 text-start">
                                      <span class="flex items-center gap-2">
                                        <span>🔴</span>
                                        <span class="text-dark">{{ $t("content.actpawn4") }}</span>
                                      </span>
                                    </td>
                                    <td class="py-1 px-2 text-end font-bold">
                                      <span class="text-dark">
                                        {{ formatDecimalString(Number(dataInfo.decPawnValue))}} บาท
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>


                        <!-- Card ชุดที่ 2 (ยอดตั๋วไถ่ถอน) -->
                        <div class="col-lg-4 col-md-6 mb-4">
                          <div class="bg-white p-3 rounded-xl flex flex-col items-center">
                              <!-- Header: จัดกลางอัตโนมัติด้วย items-center -->
                              <h5 class="text-[11px] font-bold text-gray-600 mb-2">
                                  ยอดตั๋วไถ่ถอน :  
                                  <span class="text-info">
                                      <b>{{ formatDecimalString(Number(dataInfo.redeemPawnValue) + Number(dataInfo.interestPawnValue) + Number(dataInfo.incPawnValue) + Number(dataInfo.decPawnValue))}} บาท</b>
                                  </span>
                              </h5>
                              <pre></pre>

                              <!-- Pie Chart -->
                              <div class="h-24 w-24 mb-3">
                                  <Pie :data="redeemData" :options="chartOptions" :plugins="[ChartDataLabels]" />
                              </div>

                              <!-- Table Container -->
                              <div class="w-full">
                                  <!-- จุดสำคัญ: เพิ่ม mx-auto และ w-auto เพื่อให้ตารางอยู่กึ่งกลาง Card -->
                                  <table class="table table-sm table-borderless mx-auto w-auto mb-0">
                                      <tbody class="text-[10px]">
                                          <tr>
                                              <td class="py-1 px-2">
                                                  <span class="flex items-center gap-2">
                                                      <span>🟠</span>
                                                      <span class="text-dark whitespace-nowrap">{{ $t("content.actpawn2") }}</span>
                                                  </span>
                                              </td>
                                              <td class="py-1 px-2 text-end font-bold">
                                                  <span class="text-dark">{{ formatDecimalString(Number(dataInfo.interestPawnValue))}} บาท</span>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td class="py-1 px-2">
                                                  <span class="flex items-center gap-2">
                                                      <span>🟢</span>
                                                      <span class="text-dark whitespace-nowrap">{{ $t("content.actpawn3") }}</span>
                                                  </span>
                                              </td>
                                              <td class="py-1 px-2 text-end font-bold">
                                                  <span class="text-dark">{{ formatDecimalString(Number(dataInfo.incPawnValue))}} บาท</span>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td class="py-1 px-2">
                                                  <span class="flex items-center gap-2">
                                                      <span>🔴</span>
                                                      <span class="text-dark whitespace-nowrap">{{ $t("content.actpawn4") }}</span>
                                                  </span>
                                              </td>
                                              <td class="py-1 px-2 text-end font-bold">
                                                  <span class="text-dark">{{ formatDecimalString(Number(dataInfo.decPawnValue))}} บาท</span>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td class="py-1 px-2">
                                                  <span class="flex items-center gap-2">
                                                      <span>🟡</span>
                                                      <span class="text-dark whitespace-nowrap">{{ $t("content.actpawn5") }}</span>
                                                  </span>
                                              </td>
                                              <td class="py-1 px-2 text-end font-bold">
                                                  <span class="text-dark">{{ formatDecimalString(Number(dataInfo.redeemPawnValue))}} บาท</span>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>

                      <!-- Card ชุดที่ 3 (สัดส่วนรายได้ดอกเบี้ย) -->
                      <div class="col-lg-4 col-md-6 mb-4">
                        <div class="bg-white p-3 rounded-xl flex flex-col items-center">
                          <!-- Header: จัดกลางแนวตั้ง/นอนด้วย items-center -->
                          <h5 class="text-[11px] font-bold text-gray-600 mb-2">
                            สัดส่วนรายได้ดอกเบี้ย : 
                            <span class="text-info">
                              <b>{{ formatDecimalString(Number(dataInfo.incInterestAmount)+Number(dataInfo.redeemInterestAmount)+Number(dataInfo.interestAmount)+Number(dataInfo.decInterestAmount))}} บาท</b>
                            </span>
                          </h5>
                          <pre></pre>

                          <!-- Chart: กำหนดขนาดคงที่และจัดกลาง -->
                          <div class="h-24 w-24 mb-3">
                            <Doughnut :data="interestData" :options="chartOptions" :plugins="[ChartDataLabels]"/>
                          </div>

                          <!-- Table: ใช้ mx-auto เพื่อให้ตารางอยู่กึ่งกลาง Card -->
                          <div class="w-full">
                            <table class="table table-sm table-borderless mx-auto w-auto mb-0">
                              <tbody class="text-[10px]">
                                <tr>
                                  <td class="py-1 px-2">
                                    <!-- <span class="flex items-center">
                                      <span class="d-dot me-1"></span>
                                      <span class="text-dark whitespace-nowrap">ดอกเบี้ยต่อดอก</span>
                                    </span> -->
                                    <span class="flex items-center gap-2">
                                        <span>🟠</span>
                                        <span class="text-dark">ดอกเบี้ยต่อดอก</span>
                                    </span>
                                  </td>
                                  <td class="py-1 px-2 text-end font-bold">
                                    <span class="text-dark">{{ formatDecimalString(Number(dataInfo.interestAmount))}} บาท</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1 px-2">
                                    <!-- <span class="flex items-center">
                                      <span class="d-dot1 me-1"></span>
                                      <span class="text-dark whitespace-nowrap">ดอกเบี้ยเพิ่มต้น</span>
                                    </span> -->
                                    <span class="flex items-center gap-2">
                                        <span>🟢</span>
                                        <span class="text-dark whitespace-nowrap">ดอกเบี้ยเพิ่มต้น</span>
                                    </span>
                                  </td>
                                  <td class="py-1 px-2 text-end font-bold">
                                    <span class="text-dark">{{ formatDecimalString(Number(dataInfo.incInterestAmount))}} บาท</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1 px-2">
                                    <!-- <span class="flex items-center">
                                      <span class="d-dot3 me-1"></span>
                                      <span class="text-dark whitespace-nowrap">ดอกเบี้ยลดต้น</span>
                                    </span> -->
                                    <span class="flex items-center gap-2">
                                        <span>🔴</span>
                                        <span class="text-dark whitespace-nowrap">ดอกเบี้ยลดต้น</span>
                                    </span>
                                  </td>
                                  <td class="py-1 px-2 text-end font-bold">
                                    <span class="text-dark">{{ formatDecimalString(Number(dataInfo.decInterestAmount))}} บาท</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1 px-2">
                                    <!-- <span class="flex items-center">
                                      <span class="d-dot2 me-1"></span>
                                      <span class="text-dark whitespace-nowrap">ดอกเบี้ยไถ่ถอน</span>
                                    </span> -->
                                    <span class="flex items-center gap-2">
                                        <span>🟡</span>
                                        <span class="text-dark whitespace-nowrap">ดอกเบี้ยไถ่ถอน</span>
                                    </span>
                                  </td>
                                  <td class="py-1 px-2 text-end font-bold">
                                    <span class="text-dark">{{ formatDecimalString(Number(dataInfo.redeemInterestAmount))}} บาท</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 mb-4">
                <div class="card h-100 mt-3">
                  <div class="p-3 pb-0 card-header">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">
                        <b>{{ $t("content.amnqty") }}</b>
                      </h5>

                      <h2 class="mb-0 text-info">
                        <b>
                          {{ formatNumberString(dataInfo.numOfWorkCase) }}
                        </b>
                      </h2>
                    </div>
                  </div>
                  <div class="p-3 mt-4 card-body">
                    <div class="row">
                      <div class="col-7 text-start" v-if="loading">
                        <pie-chart id="chart-times" :chart="{
                          labels: [plegde, interest, addcap, reducecap, redeem],
                          datasets: {
                            label: 'Projects',
                            data: [
                              legendTimes[0].dt,
                              legendTimes[1].dt,
                              legendTimes[2].dt,
                              legendTimes[3].dt,
                              legendTimes[4].dt,
                            ],
                            backgroundColor: colors,
                          },
                        }"
                        />
                      </div>
                      <div class="my-auto col-5">
                        <span v-for="(i, pt1) in legendTimes" :key="pt1"
                          class="badge badge-md badge-dot me-4 d-block text-start">
                          <i :class="i.bg"></i>
                          <span class="text-md text-dark">{{ i.hd }} ({{ fmNumber(i.dt)
                          }})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 mb-4">
                <div class="card h-100 mt-3">
                  <div class="p-3 pb-0 card-header">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">
                        <b>{{ $t("content.amnmoney") }}</b>
                      </h5>
                    </div>
                  </div>
                  <div class="p-3 mt-4 card-body">
                    <div class="row">
                      <div class="col-7 text-start" v-if="loading">
                        <pie-chart id="chart-baht" :chart="{
                          labels: [plegde, interest, addcap, reducecap, redeem],
                          datasets: {
                            label: 'Projects',
                            data: [
                              legendBaht[0].dt,
                              legendBaht[1].dt,
                              legendBaht[2].dt,
                              legendBaht[3].dt,
                              legendBaht[4].dt,
                            ],
                            backgroundColor: colors,
                          },
                          options: null,
                        }" />
                      </div>
                      <div class="my-auto col-5">
                        <span v-for="(i, pt2) in legendBaht" :key="pt2"
                          class="badge badge-md badge-dot me-4 d-block text-start">
                          <i :class="i.bg"></i>
                          <span class="text-md text-dark">{{ i.hd }} ({{
                            formatNumberDecimalString(i.dt) }})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 mb-4">
                <div class="card h-100 mt-3">
                  <div class="p-3 pb-0 card-header">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">
                        <b>{{ $t("content.amncashflow") }}</b>
                      </h5>
                    </div>
                  </div>
                  <div class="p-3 pb-0 card-header">
                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="mb-0 text-info">
                        <b>
                          <span class="text-md text-dark">{{ $t("content.amnoutcome") }} :
                          </span>
                          <span style="color:red">
                            {{ formatDecimalString(dataInfo.payAmount) }}
                          </span>
                        </b>
                      </h6>
                      <h6 class="mb-0 text-info">
                        <b>
                          <span class="text-md text-dark">{{ $t("content.amnincome") }} :
                          </span>
                          <span style="color:green">
                            {{ formatDecimalString(dataInfo.receiveAmount) }}
                          </span>
                        </b>
                      </h6>

                      <h6 class="mb-0 text-info">
                        <b>
                          <span class="text-md text-dark">
                            <span v-if="dataInfo.sumInterest > 0" @click="goToRpProfit()"
                              style="text-decoration:underline;cursor: pointer">
                              {{ $t("content.amninterest") }}
                            </span>
                            <span v-else>
                               {{ $t("content.amninterest") }}
                            </span> :
                          </span>
                          <span class="text-info">
                            {{ formatDecimalString(dataInfo.sumInterest) }}
                          </span>
                        </b>
                      </h6>
                    </div>
                  </div>
                  <div class="p-3 mt-4 card-body">
                    <div class="row">
                      <div class="col-7 text-start" v-if="loading">
                        <pie-chart id="chart-sum" :chart="{
                          labels: [sincome, soutcome, sinterest],
                          datasets: {
                            label: 'Projects',
                            data: [
                              legendSum[1].dt,
                              legendSum[0].dt,
                              legendSum[2].dt,
                            ],
                            backgroundColor: colors2,
                          },
                        }" />
                      </div>
                      <div class="my-auto col-5">
                        <span v-for="(i, pt2) in legendSum" :key="pt2"
                          class="badge badge-md badge-dot me-4 d-block text-start">
                          <i :class="i.bg"></i>
                          <span class="text-md text-dark">{{ i.hd }} ({{
                            formatNumberDecimalString(i.dt) }})</span>
                        </span>
                      </div>

                    </div>

                  </div>
                </div>
              </div>

              <div class="col-lg-6 mb-4">
                <div class="card h-100 mt-3">
                  <div class="p-3 pb-0 card-header">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">
                        <b>{{ $t("content.amnmigflow") }}</b>
                      </h5>
                    </div>
                  </div>
                  <div class="p-3 pb-0 card-header">
                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="mb-0 text-info">
                        <b>
                          <span class="text-md text-dark">{{ $t("content.amnoutcome") }} :
                          </span>
                          <span style="color:red">
                            {{ formatDecimalString(dataInfo.totalPayMigration) }}
                          </span>
                        </b>
                      </h6>
                      <h6 class="mb-0 text-info">
                        <b>
                          <span class="text-md text-dark">{{ $t("content.amnincome") }} :
                          </span>
                          <span style="color:green">
                            {{ formatDecimalString(dataInfo.totalReceiveMigration) }}
                          </span>
                        </b>
                      </h6>
                    </div>
                  </div>
                  <div class="p-3 mt-4 card-body">
                    <div class="row">
                      <div class="col-7 text-start" v-if="loading">
                        <pie-chart id="chart-mig" :chart="{
                          labels: [interest, addcap, reducecap],
                          datasets: {
                            label: 'Projects',
                            data: [
                              legendMig[0].dt,
                              legendMig[1].dt,
                              legendMig[2].dt,
                            ],
                            backgroundColor: colors,
                          },
                        }" />
                      </div>
                      <div class="my-auto col-5">
                        <span v-for="(i, pt2) in legendMig" :key="pt2"
                          class="badge badge-md badge-dot me-4 d-block text-start">
                          <i :class="i.bg"></i>
                          <span class="text-md text-dark">{{ i.hd }} {{
                            formatDecimalString(i.dt) }} ({{ fmNumber(i.dt2)
                            }})</span>
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="col-12 mb-4">
                <div class="card h-100 mt-3">
                  <div class="p-3 pb-0 card-header">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">
                        <b>{{ $t("content.amndue") }}</b>
                      </h5>
                    </div>
                  </div>
                  <div class="p-3 mt-2 card-body">
                    <div class="row">
                      <div v-for="(a, pt3) in legendDue" :key="pt3" class="col-12 text-start mb-3">
                        <div class="d-flex justify-content-between align-items-center">
                          <p class="mb-1">{{ a.hd }}</p>
                          <div class="d-flex align-items-center">
                            <h4 class="mb-0">
                              <b><span :class="a.tx">{{ fmNumber(a.vs) }}</span></b>
                            </h4>
                            &nbsp;
                            <p class="text-sm mb-0">/{{ fmNumber(a.vm) }}</p>
                          </div>
                        </div>

                        <div class="progress dashboard">
                          <div v-if="a.vs !== 0 && a.vm !== 0" class="progress-bar" :class="a.bg" role="progressbar"
                            :style="'width: ' + calPercent(a.vs, a.vm) + '%;'" :aria-valuenow="calPercent(a.vs, a.vm)"
                            aria-valuemin="0" aria-valuemax="100">
                            {{ Number(calPercent(a.vs, a.vm)).toLocaleString() }}%
                          </div>
                          <div v-else class="progress-bar" :class="a.bg" role="progressbar"
                            :style="'width: ' + 2 + '%;'" :aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                            0%
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4" style="overflow-x: auto; padding-right: 1em">
                      <h5 class="">{{ $t("content.amnticketduelist") }}</h5>
                      <div class="table-responsive">
                        <table class="table">
                          <thead class="thead-light">
                            <tr>
                              <th>#</th>
                              <th>{{ $t("content.amnduedate") }}</th>
                              <th>{{ $t("content.amndeferdate") }}</th>
                              <th>{{ $t("content.names") }}</th>
                              <th>{{ $t("content.ticketno") }}</th>
                              <th>{{ $t("content.allweight") }}</th>
                              <th>{{ $t("content.allqty") }}</th>
                              <th>{{ $t("content.allprice") }}</th>
                              <th>{{ $t("content.cintrate") }}</th>
                              <th>{{ $t("content.act") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in duelist" :key="index">
                              <td class="text-sm font-weight-normal">{{
                                formatNumberString((currentPage - 1) * perPage + index
                                  +
                                  1) }}</td>
                              <td class="text-sm font-weight-normal">
                                {{ format_date(row.dueDate) }}</td>
                              <td class="text-sm font-weight-normal">
                                {{ format_date(row.postponeDate) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                <span @click="searchCustomer(row)"
                                  style="color:blue;text-decoration:underline;cursor: pointer">
                                  {{ row.cusName }}
                                </span>
                                <material-button data-bs-toggle="modal" data-bs-target="#exampleModal"
                                  id="exampleModalShow" v-show="false">
                                </material-button>
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ row.refNumber }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberDecimalString(row.weight) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberString(row.quantity) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberDecimalString(row.newPawnValue) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberDecimalString(row.interestPerMonth) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                <material-button color="info" variant="outline" class="rounded-circle"
                                  :title="t('buttons.seed')" @click="openDetail(row)">
                                  <i class="material-icons material-symbols-outlined">visibility</i>
                                </material-button>
                                <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                                  data-bs-toggle="modal" data-bs-target="#lookupModal" id="detailModal">
                                </material-button>
                              </td>
                            </tr>
                            <tr v-if="duelist.length === 0">
                              <td colspan="11" class="text-sm font-weight-normal">
                                <p style="text-align: center">No Record Found</p>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="14" style="text-align: right">Total Rows : {{
                                totalRows_s }}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <pre></pre>
                    <div style="display: flex; justify-content: flex-end">
                      <ul v-show="duelist.length > 0" class="pagination justify-content-end">
                        <div class="project-container">
                          <div class="example-one">
                            <vue-awesome-paginate v-model="currentPage" :total-items="totalRows"
                              :items-per-page="perPage" @click="onClickHandler" />
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div id="tab2" class="tab-pane fade" role="tabpanel" aria-labelledby="tab2-tab">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="card h-100 mt-3">
                  <div class="card-header mb-0">
                    <h5>{{ $t("content.repredeint") }}</h5>
                  </div>
                  <div class="card-body pt-0">
                    <div class="row">
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.sdate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker v-model="start_dater" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.edate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker v-model="end_dater" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-2 me-3">
                        <span class="form-label m-0"></span>
                        <div class="d-inline-block mx-4">
                          <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                            @click="loadRedeemReportApi" :disabled="start_dater > end_dater">
                            <i class="material-icons material-symbols-outlined">search</i>
                            {{ search }}
                          </material-button>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="table-responsive">
                        <table class="table table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th>{{ $t("content.months") }}</th>
                              <th>{{ $t("content.be_year") }}</th>
                              <th>{{ $t("content.numamount") }}</th>
                              <th>{{ $t("content.amount") }}</th>
                              <th>{{ $t("content.amnrealprofit") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in reportlist" :key="index">
                              <td class="text-sm font-weight-normal">
                                {{ filterMonths(row.month) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ setyears(row.year) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberString(row.ticket) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberDecimalString(row.pawnValue) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberDecimalString(row.interest) }}
                              </td>
                            </tr>
                            <tr v-if="reportlist.length === 0">
                              <td colspan="10" class="text-sm font-weight-normal">
                                <p style="text-align: center">No Record Found</p>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr v-if="reportlist.length > 0">
                              <td class="text-lg font-weight-bold text-end text-center" colspan="2">
                                <span v-if="reportlist.length > 0">
                                  <b>{{ $t("content.gtotal") }}</b>
                                </span>
                              </td>
                              <td class="text-lg font-weight-bold">
                                <span v-if="reportlist.length > 0">
                                  <b>{{ formatNumberString(totalTicket) }}</b>
                                </span>
                              </td>
                              <td class="text-lg font-weight-bold">
                                <span v-if="reportlist.length > 0">
                                  <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                                </span>
                              </td>
                              <td class="text-lg font-weight-bold">
                                <span v-if="reportlist.length > 0">
                                  <b>{{ formatNumberDecimalString(totalInterest) }}</b>
                                </span>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="tab3" class="tab-pane fade" role="tabpanel" aria-labelledby="tab3-tab">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="card mt-3">
                  <div class="card-header mb-0">
                    <h5>{{ $t("content.detail") }}</h5>
                  </div>
                  <div class="card-body pt-0">
                    <div class="row">
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.sdate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker v-model="start_datet" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.edate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker v-model="end_datet" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-2 me-3">
                        <span class="form-label m-0"></span>
                        <div class="d-inline-block mx-4">
                          <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                            :disabled="start_datet > end_datet" @click="searchTransactionsInfo">
                            <i class="material-icons material-symbols-outlined">search</i>
                            {{ search }}
                          </material-button>
                        </div>
                      </div>
                    </div>

                    <div class="summary-row mt-3 me-3" v-if="summaryDetail !== null">
                      <div class="d-flex justify-content-between align-items-center gap-3">
                        
                        <!-- รายการที่ 1: จำนวนตั๋ว (สีน้ำเงิน) -->
                        <div class="summary-card color-blue">
                          <div class="item-content">
                            <span class="label">{{ $t("content.numberactive") }}</span>
                            <span class="value">{{ formatNumberString(summaryDetail.ticket) }}</span>
                          </div>
                        </div>

                        <!-- รายการที่ 2: จำนวนลูกค้า (สีเขียว) -->
                        <div class="summary-card color-green">
                          <div class="item-content">
                            <span class="label">{{ $t("content.amnenter") }}</span>
                            <span class="value">{{ formatNumberString(summaryDetail.customer) }}</span>
                          </div>
                        </div>

                        <!-- รายการที่ 3: ลายนิ้วมือผู้มีอำนาจ (สีแดง/ชมพู) -->
                        <div class="summary-card color-red">
                          <div class="item-content">
                            <span class="label">{{ $t("content.amtkrepresent") }}</span>
                            <span class="value">{{ formatNumberString(summaryDetail.shopRepresent) }}</span>
                          </div>
                        </div>
                      </div>
                      <pre></pre><pre></pre><pre></pre>
                    </div>

                    
                    <div class="row mt-3 me-3">
                      <div class="table-responsive">
                        <table class="table table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th class="align-top text-center">{{ $t("content.amnchannel") }}</th>
                              <th class="align-top text-center">{{ $t("content.trans") }}</th>
                              <th class="align-top text-center">{{ $t("content.amnticall") }}</th>
                              <th class="align-top text-center">{{ $t("content.amntotalval") }}</th>
                              <th class="align-top text-center">{{ $t("content.massetgroup") }}</th>
                              <th colspan ="4" class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                 {{ $t("content.idcard") }}
                                </span>
                              </th>
                              <th class="align-top text-center">{{ $t("content.autfingerprint") }}</th>
                            </tr>
                            <tr>
                              <th colspan="5"></th>
                              <th colspan="2" class="align-top text-center"
                                style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.usecard") }}
                                </span>
                              </th>
                              <th colspan="2" class="align-top text-center"
                                style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.donusecard") }}
                                </span>
                              </th>
                              <th class="align-top text-center"></th>
                            </tr> 
                            <tr>
                              <th colspan="5"></th>
                              <th class="align-top text-center"
                                style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.donuseotp") }}
                                </span>
                              </th>
                              <th class="align-top text-center"
                                style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.useotp") }}
                                </span>
                              </th>
                              <th class="align-top text-center"
                                style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.donuseotp") }}
                                </span>
                              </th>
                              <th class="align-top text-center"
                                style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.useotp") }}
                                </span>
                              </th>
                              <th class="align-top text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in tranlist" :key="index"
                               :class="{ 'group-start': row.isFirstInGroup, 'group-end': row.isLastInGroup }">
                              <td class="text-sm font-weight-bold text-center">
                                <template v-if="row.isFirstInGroup">
                                  <span style="color:blue; font-weight:bold;" v-if="row.channel === 'normal'">{{ $t("content.cintrate1") }}</span>
                                  <span style="color:blue; font-weight:bold;" v-else-if="row.channel === 'migration'">{{ $t("content.transmig") }}</span>
                                  <span style="color:blue; font-weight:bold;" v-else-if="row.channel === 'outage'">{{ $t("content.outage2") }}</span>
                                  <span style="color:blue; font-weight:bold;" v-else-if="row.channel === 'outage-migration'">{{ $t("content.outage2") }} ({{ $t("content.transmig") }})</span>
                                  <span style="color:blue; font-weight:bold;" v-else-if="row.channel === 'line'">Line OA</span>
                                  <!-- ถ้าเป็นค่าว่าง ให้แสดงขีดหรือข้อความ default -->
                                  <span v-else></span> 
                                </template>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                {{ checkTransaction2(row.type) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                {{ formatNumberString(row.total) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                {{ formatNumberDecimalString(row.pawnValue) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <material-button color="info" variant="outline" class="rounded-circle"
                                  :title="t('buttons.seed')" @click="getCatDetailInfo(row)">
                                  <i class="material-icons material-symbols-outlined">manage_search</i>
                                </material-button>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span v-if="Number(row.idNoOtp) > 0" @click="goToHistory_detail(13,row.channel,row.type)"
                                  style="text-decoration:underline;cursor: pointer;color:blue;">
                                    {{ formatNumberString(row.idNoOtp) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span v-if="Number(row.idOtp) > 0" @click="goToHistory_detail(14,row.channel,row.type)"
                                  style="text-decoration:underline;cursor: pointer;color:blue;">
                                    {{ formatNumberString(row.idOtp) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span v-if="Number(row.noIdNoOtp) > 0" @click="goToHistory_detail(15,row.channel,row.type)"
                                  style="text-decoration:underline;cursor: pointer;color:blue;">
                                    {{ formatNumberString(row.noIdNoOtp) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span v-if="Number(row.noIdOtp) > 0" @click="goToHistory_detail(16,row.channel,row.type)"
                                  style="text-decoration:underline;cursor: pointer;color:blue;">
                                    {{ formatNumberString(row.noIdOtp) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span v-if="Number(row.shopRepresent) > 0" @click="goToHistory_detail(17,row.channel,row.type)"
                                  style="text-decoration:underline;cursor: pointer;color:blue;">
                                    {{ formatNumberString(row.shopRepresent) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                            </tr>
                            <tr v-if="tranlist.length === 0">
                              <td colspan="10" class="text-sm font-weight-normal">
                                <p style="text-align: center">No Record Found</p>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                  <pre></pre><pre></pre><pre></pre>
                </div>

                <div class="col-12 mb-3">
                  <div class="card mt-3">
                    <div class="card-header mb-0">
                      <h5>{{ $t("content.graphcustran") }}</h5>
                    </div>
                    <div class="card-body pt-0">
                      <div class="row">
                        <div class="col-12 mb-4">
                          <div class="p-3 mt-2 card-body">
                            <div class = "row" v-if="graphDataDetail !== null">                            
                                <TransactionChart :transactions="graphDataDetail" />
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                  </div>
                </div>

              </div>
             </div>
          </div>
        

        </div>

        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">
                  {{ $t('content.bcustomer') }} :
                  <span style="color: blue;">
                    {{ cusShop.cusName }}
                  </span>
                </h1>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row mt-2">
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t('content.cmobile') }}1*</label>
                    <InputMask v-model="cusShop.phoneNo1" mask="(999) 999-9999" fluid disabled />
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t('content.cmobile') }}2</label>
                    <InputMask v-model="cusShop.phoneNo2" mask="(999) 999-9999" fluid disabled />
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t('content.cmobile') }}3</label>
                    <InputMask v-model="cusShop.phoneNo3" mask="(999) 999-9999" fluid disabled />
                  </div>
                  <pre></pre>
                  <div class="col-4">
                    <label class="form-label ms-0">{{ $t('content.amntypecustomer') }}</label>
                    <select class="form-select" v-model="cusShop.cusTypeUid" disabled>
                      <option value="0" disabled selected>{{ $t('content.select') }}</option>
                      <option v-for="(item, index) in custypeList" :value="item.uid" :key="index">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-4">
                    <div class="flex-auto">
                      <label class="form-label ms-0">{{ $t('content.amncredit') }}</label>
                      <InputNumber v-model="cusShop.creditAmount" autocomplete="off" disabled fluid />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="flex-auto">
                       <label class="form-label ms-0" style="color:blue">Line ID</label>
                      <material-input v-model="displayName" type="text" disabled/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
              </div>
            </div>
          </div>
        </div>


        <!-- Detail Modal -->
        <div id="lookupModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1240px;">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">

                <div class="row">
                  <div class="col-lg-6 mt-2">
                    <div id="lookupImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false"
                      style="max-width: 520px">
                      <div class="carousel-indicators" id="demo1">
                      </div>
                      <div class="carousel-inner">
                        <ul className="list-unstyled">
                          <li v-for="(item, index) in images.length" :key="index">
                            <span v-if="index === 0">
                              <div class="carousel-item active">
                                <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                  class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                  message-pos="top" />
                              </div>
                            </span>
                            <span v-else>
                              <div class="carousel-item">
                                <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                  class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                  message-pos="top" />
                              </div>
                            </span>
                          </li>
                        </ul>
                      </div>
                      <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button" data-bs-target="#lookupImages"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-lg-6 mt-2">
                    <div v-if="workcaseDetail !== null" style="overflow-x:auto;">
                      <div>
                        <table class="table table-sm table-borderless">
                          <tbody>
                            <tr>

                              <td class="fs-14 text-bold">{{ $t("content.ticketno") }} :
                                <span v-if="workcaseDetail.tkRefNumber !== ''">
                                  {{ workcaseDetail.tkRefNumber }} &nbsp;
                                  <span @click='copyBtn()' style="cursor: pointer">
                                    <i class="inline-icon material-icons">content_copy</i>
                                  </span>
                                </span>
                                <span v-else>-</span>
                              </td>
                              <td class="fs-14 text-bold">{{ $t("content.stkeeptk") }} :
                                <span v-if="workcaseDetail.deposit" style="color:green;">
                                  {{ $t("content.stdeposittk") }} ({{ dep_ref }})
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>

                            </tr>
                            <tr>
                              <td class="fs-14 text-bold">{{ $t("content.trans") }} :
                                {{ checkTransaction(workcaseDetail.transactionType) }}
                              </td>
                              <td class="fs-14 text-bold">{{ $t("content.statusticket") }} :
                                <span v-if="workcaseDetail.status === 'FINISH'" style="color:green;">
                                  {{ tk_status }}
                                </span>
                                <span v-else-if="workcaseDetail.status === 'FREEZE' || workcaseDetail.status === 'TERMINATE'
                                  || workcaseDetail.status === 'BREAKING'" style="color:red;">
                                  <span v-if="workcaseDetail.status === 'BREAKING'">
                                    {{ tk_status }} ({{ format_date(workcaseDetail.breakingDate) }} : {{
                                      workcaseDetail.lotNumber }})
                                  </span>
                                  <span v-else>
                                    {{ tk_status }}
                                  </span>
                                </span>
                                <span v-else>
                                  {{ tk_status }}
                                </span>
                              </td>
                            </tr>
                            <tr v-if="workcaseDetail.postponeCount === 0">
                              <td class="fs-14 text-bold"> {{ $t("content.lasttrf") }} : {{
                                format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                              <td class="fs-14 text-bold">
                                {{ $t("content.amnduedate") }} :
                                <span style="color:red;">
                                  {{ format_date(workcaseDetail.dueDate) }}
                                </span>
                              </td>
                            </tr>
                            <tr v-if="workcaseDetail.postponeCount !== 0">
                              <td class="fs-14 text-bold" colspan="2"> {{ $t("content.lasttrf") }} : {{
                                format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                            </tr>
                            <tr v-if="workcaseDetail.postponeCount !== 0">
                              <td class="fs-14 text-bold" colspan="2">
                                {{ $t("content.amnduedate") }} :
                                <span style="color:red;">
                                  {{ format_date(workcaseDetail.dueDate) }} (ขอเลื่อนเป็นวันที่ {{
                                    format_date(workcaseDetail.postponeDate) }})
                                </span>
                              </td>
                            </tr>
                            <tr v-if="workcaseDetail.postponeCount !== 0">
                              <td class="fs-14 text-bold" colspan="2">
                                {{ $t("content.deferpast") }} :
                                <span @click='NewTab()' style="text-decoration: underline;color:red; cursor: pointer">
                                  {{ workcaseDetail.postponeCount }}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold">
                                {{ $t("content.monthlyprofn") }} : {{
                                  formatNumberDecimalString(workcaseDetail.interestPerMonth) }}
                                <span style="color:red;">
                                  ({{ format_date(new Date()) }})
                                </span>
                              </td>
                              <td class="fs-14 text-bold">
                                {{ $t("content.currentprof") }} :
                                <span style="color:red;">
                                  {{ formatNumberDecimalString(int_cal) }}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold">
                                {{ $t("content.ttprointerest") }} :
                                <span
                                  v-if="workcaseDetail.interestPromotion === null || workcaseDetail.interestPromotion === 0">
                                  -
                                </span>
                                <span style="color:blue;" v-else>
                                  {{ formatNumberDecimalString(workcaseDetail.interestPromotion) }}
                                </span>
                              </td>
                              <td class="fs-14 text-bold">
                                {{ $t("content.periodpromotion") }} :
                                <span v-if="workcaseDetail.promotionDuration === 0">
                                  -
                                </span>
                                <span style="color:blue;" v-else>
                                  {{ workcaseDetail.promotionDuration }} เดือน
                                </span>
                              </td>
                            </tr>
                            <template v-if="workcaseDetail.interestPromotion !== 0 && promotionDetail !== null">
                                <tr v-for="(item, index) in promotionDetail.interests" :key="item.id">
                                  <div v-if="item.promotion" class="fs-14 text-bold" style="display: flex; width: 100%;">
                                      <!-- คอลัมน์ซ้าย: กำหนดความกว้างคงที่เพื่อให้ย่อหน้าตรงกัน -->
                                      <div style="width: 70px;">
                                        เดือนที่ {{ index + 1 }} :
                                      </div>
                                      <!-- คอลัมน์ขวา: แสดงตัวเลขสีน้ำเงิน -->
                                      <div style="color:blue;">
                                        {{ item.interestVal.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                                      </div>
                                  </div>
                                </tr>
                            </template>
                            <tr>
                              <td class="fs-14 text-bold">{{ $t("content.periodpawnn") }} :
                                <span style="color:blue;">
                                  {{ int_period }} เดือน
                                </span>
                              </td>
                              <td class="fs-14 text-bold">{{ $t("content.amnbookno") }}
                                <span style="color:blue;">
                                  {{ workcaseDetail.tkVolNo }}
                                </span>
                                &nbsp;{{ $t("content.amnno") }}
                                <span style="color:blue;">
                                  {{ workcaseDetail.tkNo }}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold">{{ $t("content.amnqtypiece") }} :
                                {{ formatNumberString(workcaseDetail.ticket.totalQuantity) }}
                              </td>
                              <td class="fs-14 text-bold">{{ $t("content.allweight") }} :
                                {{ formatNumberDecimalString(workcaseDetail.ticket.totalWeight) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold">{{ $t("content.pawnvalpv") }} :
                                <span v-if="workcaseDetail.transactionType === 'PAWN'">
                                  {{ formatNumberDecimalString(0) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(workcaseDetail.pawnValue) }}
                                </span>
                              </td>
                              <td class="fs-14 text-bold">{{ $t("content.actpawn3") }}/{{ $t("content.actpawn4") }} :
                                {{ formatNumberDecimalString(workcaseDetail.diffValue) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold">{{ $t("content.amnanalysval") }} :
                                {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                              </td>
                              <td class="fs-14 text-bold">{{ $t("content.amnmaxvalall") }} :
                                {{ formatNumberDecimalString(workcaseDetail.ticket.totalFullValue) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold">{{ $t("content.statusticketlost") }} :
                                <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> ไม่มี
                                </span>
                                <span v-else style="color:red;">
                                  มี ({{ workcaseDetail.lostCount }})
                                </span>
                              </td>
                              <td class="fs-14 text-bold">{{ $t("content.refnolost") }} :
                                <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> -
                                </span>
                                <span v-else style="color:red;">
                                  {{ workcaseDetail.lostRefNumber }}
                                </span>
                              </td>
                            </tr>
                            <tr v-if="workcaseDetail.represent || workcaseDetail.shopRepresent">
                              <td class="fs-14 text-bold" colspan="2"> {{ $t("content.represent") }} :
                                <span style="color:red;">
                                  {{workcaseDetail.customerInfo.name}}
                                </span>
                              </td>
                            </tr>
                            <tr v-if="workcaseDetail.changeName">
                              <td class="fs-14 text-bold" colspan="2"> {{ $t("content.changeName") }} ({{ bf_changename }}) :
                                  <span style="color:red;">
                                    {{ af_changename }}
                                  </span>
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold" colspan="2"> {{ $t("content.transoutage") }} :
                                <span v-if="workcaseDetail.outage" style="color:red">
                                  {{ $t("content.yes") }}
                                </span>
                                <span v-else style="color:green">
                                  {{ $t("content.no") }}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold" colspan="2"> {{ $t("content.amnlocationasset") }} :
                                <span v-if="workcaseDetail.ticket.locationName !== null">
                                  {{ workcaseDetail.ticket.locationName }}
                                </span>
                                <span v-else>
                                  -
                                </span>

                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold" colspan="2"> {{ $t("content.stockno") }} :
                                <span v-if="workcaseDetail.ticket.stockNumber !== null">
                                  {{ workcaseDetail.ticket.stockNumber }}
                                </span>
                                <span v-else>
                                  -
                                </span>

                              </td>
                            </tr>
                            <tr>
                              <td class="fs-14 text-bold" colspan="2"> {{ $t("content.migraref") }} :
                                <span v-if="workcaseDetail.migrateRefNumber !== null">
                                  {{ workcaseDetail.migrateRefNumber }}
                                </span>
                                <span v-else>
                                  -
                                </span>

                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <span v-if="listinfo.length !== 0">
                          <table class="table table-sm table-borderless">
                            <tbody>
                              <tr>
                                <td class="fs-14 text-bold">
                                  <span style="text-decoration:underline;">
                                    {{ $t("content.amnassetdetail") }}
                                  </span>
                                </td>
                              </tr>

                              <tr v-for="(row, index) in listinfo" :key="index">
                                <td class="fs-14 text-bold">
                                  {{ formatNumberString(index + 1) }}. {{ row.remark }}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                        </span>
                        <span v-else>
                          <tr>
                            <td class="fs-14 text-bold">
                              <span style="text-decoration:underline;">
                                {{ $t("content.amnassetdetail") }}
                              </span>
                              : -
                            </td>

                          </tr>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr v-if="paymentE !== ''" />
                <div class="col-12 mt-2" v-if="paymentE !== ''">
                  <div class="fs-14 text-bold">
                    <span style="text-decoration:underline;">
                      {{ $t("content.amnfinanceinfo") }}
                    </span>
                  </div>
                  <pre></pre>
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-flush">
                        <thead class="thead-light">
                          <tr>
                            <th>#</th>
                            <th>{{ $t("content.ticketno") }}</th>
                            <th>{{ $t("content.amnbiz") }}</th>
                            <th colspan="5" class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amnincome") }}
                              </span>
                            </th>
                            <th colspan="4" class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amnoutcome") }}
                              </span>
                            </th>
                            <th colspan="4" class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.fee") }}
                              </span>
                            </th>
                          </tr>
                          <tr>
                            <th colspan="3"></th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amncash") }}
                              </span>
                            </th>
                            <th colspan="2" class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amnbanktransfer") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amncreditcard") }}
                              </span>

                            </th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amncheque") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amncash") }}
                              </span>
                            </th>
                            <th colspan="3" class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amnbanktransfer") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.amncash") }}
                              </span>
                            </th>
                            <th colspan="2" class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.amnbanktransfer") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.amncreditcard") }}
                              </span>
                            </th>
                          </tr>
                          <tr>
                            <th colspan="3"></th>
                            <th style="background-color:#dfffdd;"></th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amnbankacc") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                QR Code
                              </span>
                            </th>
                            <th colspan="2" style="background-color:#dfffdd;"></th>
                            <th style="background-color:#fecac7;"></th>
                            <th class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amnbankacc") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amntransfer_promt_mobile") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amntransfer_promt_taxid") }}
                              </span>
                            </th>
                            <th style="background-color:#CFEBFD;"></th>
                            <th class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.amnbankacc") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                QR Code
                              </span>
                            </th>
                            <th style="background-color:#CFEBFD;"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in paymentE.workCases" :key="index">
                            <template v-if="row.ticket !== null">
                              <td class="text-sm font-weight-normal text-center">{{ formatNumberString(index + 1) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">{{ row.tkRefNumber }}</td>
                              <td class="text-sm font-weight-normal text-center">{{
                                checkTransaction(row.transactionType) }}</td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[0].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[0].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[1].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[1].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[6].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[6].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[2].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[2].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[3].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[3].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[0].pay > 0" style="color:red;">
                                  {{ formatNumberDecimalString(payment_l[0].pay) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[1].pay > 0" style="color:red;">
                                  {{ formatNumberDecimalString(payment_l[1].pay) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[4].pay > 0" style="color:red;">
                                  {{ formatNumberDecimalString(payment_l[4].pay) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[5].pay > 0" style="color:red;">
                                  {{ formatNumberDecimalString(payment_l[5].pay) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[0].fee > 0" style="color:blue;">
                                  {{ formatNumberDecimalString(payment_l[0].fee) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[1].fee > 0" style="color:blue;">
                                  {{ formatNumberDecimalString(payment_l[1].fee) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[6].fee > 0" style="color:blue;">
                                  {{ formatNumberDecimalString(payment_l[6].fee) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[2].fee > 0" style="color:blue;">
                                  {{ formatNumberDecimalString(payment_l[2].fee) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                            </template>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <!-- Detail UserWork Modal -->
        <div class="modal fade" id="detailUserWorkModal"  aria-labelledby="detailUserWorkLabel"
          aria-hidden="true">
         <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1240px;">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="detailUserWorkModalLabel">
                  <span v-if="userq === 'Q01'">
                    {{ $t("content.workQ01") }} : {{ formatNumberString(num_q01) }}
                  </span>
                  <span v-else-if="userq === 'Q02'">
                    {{ $t("content.workQ02") }} : {{ formatNumberString(num_q02) }}
                  </span>
                  <span v-else-if="userq === 'Q03'">
                    {{ $t("content.workQ03") }} : {{ formatNumberString(num_q03) }}
                  </span>
                  <span v-else-if="userq === 'Q04'">
                    {{ $t("content.workQ04") }} : {{ formatNumberString(num_q04) }}
                  </span>
                  <span v-else-if="userq === 'QPAY'">
                    {{ $t("content.workQpay") }} : {{ formatNumberString(num_pay) }}
                  </span>
                </h1>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>
              <div class="modal-body">
                <table class="table table-sm table-borderless" v-if="userq !== 'QPAY'">
                  <tbody>
                    <tr>
                      <td class="text-dark">
                        <h6><b>
                            #
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.time") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.jobId") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.item") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.cname") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.refnumberold") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.refnumbernew") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.amnanalysval") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.gpay") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark text-center">
                        <h6><b>
                            {{ $t("content.amnassetdetail") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark text-center">
                        <h6><b>
                            {{ $t("content.amnassetimage") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark text-center">
                        <h6><b>
                            {{ $t("content.amnlastmaker") }}
                          </b>
                        </h6>
                      </td>
                      
                    </tr>
                    <tr v-for="(row, index) in list_userq" :key="index">
                      <td class="text-md text-dark">
                          {{ formatNumberString(index + 1) }}
                      </td>
                      <td class="text-md text-dark">
                          {{ format_time(row.startTime) }}
                      </td>
                      <td class="text-md text-dark">
                          {{ row.jobId }}
                      </td>
                      <td class="text-md text-dark">
                        <span v-if="row.migration"> 
                          {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }})
                        </span>
                        <span v-else>
                          {{ checkTransaction(row.type) }}
                        </span>
                      </td>
                      <td class="text-md text-dark">
                        <span v-if="row.changeName">
                          {{ row.customerName }}
                        </span>
                        <span v-else>
                          {{ row.tkCustomerName }}
                        </span>
                      </td>
                      <td class="text-md text-dark">
                        {{ row.prevRefNumber }}
                      </td>
                      <td class="text-md text-dark">
                        {{ row.refNumber }}
                      </td>
                      <td class="text-md text-dark">
                        <span v-if="row.type !== 'PAYMENT'">
                          {{ formatNumberDecimalString(row.newPawnValue) }}
                        </span>
                      </td>
                      <td class="text-md text-dark">
                        <span v-if="row.type !== 'PAYMENT'">
                          <span v-if="row.totalPay !== 0" style="color:red">
                            {{ formatNumberDecimalString(row.totalPay) }}
                          </span>
                          <span v-else-if="row.totalReceive !== 0" style="color:green">
                            {{ formatNumberDecimalString(row.totalReceive) }}
                          </span>
                          <span v-else>
                            {{ formatNumberDecimalString(row.totalReceive) }} 
                          </span>
                        </span>
                      </td>
                      <td class="text-md text-dark text-center">
                        <span v-if="row.type !== 'PAYMENT'">
                          <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="getCollecteral(row.workCaseUid , 'coll')">
                              <i class="material-icons material-symbols-outlined">manage_search</i>
                          </material-button>
                        </span>
                      </td>
                      <td class="text-md text-dark text-center">
                         <span v-if="row.type !== 'PAYMENT'">
                          <material-button color="success" variant="outline" class="rounded-circle"
                              :title="t('content.viewimg')" @click="getCollecteral(row.workCaseUid, 'img')">
                              <i class="material-icons material-symbols-outlined">photo_library</i>
                          </material-button>
                        </span>
                      </td>
                      <td class="text-md text-info text-center">
                        <span v-if="row.ownerUid !== '0'">
                          {{ row.ownerName }}
                        </span>
                        <span v-else style="color:red;">
                          -
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                  <table class="table table-sm table-borderless" v-else>
                    <tbody>
                      <tr>
                        <td class="text-dark">
                          <h6><b>
                              #
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark">
                          <h6><b>
                              {{ $t("content.time") }}
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark">
                          <h6><b>
                              {{ $t("content.jobId") }}
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark">
                          <h6><b>
                              {{ $t("content.cname") }}
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark">
                          <h6><b>
                              {{ $t("content.amntotalval") }}
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark text-center">
                          <h6><b>
                              {{ $t("content.amnlastmaker") }}
                            </b>
                          </h6>
                        </td>
                      </tr>
                      <tr v-for="(row, index) in list_pay" :key="index">
                        <td class="text-md text-dark">
                          {{ formatNumberString(index + 1) }}
                        </td>
                        <td class="text-md text-dark">
                          {{ format_time(row.startTime) }}
                        </td>
                        <td class="text-md text-dark">
                          {{ row.jobId }}
                        </td>
                        <td class="text-md text-dark">
                          {{ row.customerName }}
                        </td>
                        <td class="text-md text-dark">
                          <span v-if="row.roundTotalPay !== 0" style="color:red">
                            {{ formatNumberDecimalString(row.roundTotalPay) }}
                          </span>
                          <span v-else-if="row.roundTotalReceive !== 0" style="color:green">
                            {{ formatNumberDecimalString(row.roundTotalReceive) }}
                          </span>
                          <span v-else>
                            {{ formatNumberDecimalString(row.roundTotalReceive) }}
                          </span>
                        </td>
                        <td class="text-md text-info text-center">
                          <span v-if="filterUserOwner(row.workItemUid) !== ''">
                            {{ filterUserOwner(row.workItemUid)}}
                          </span>
                          <span v-else style="color:red;">
                            -
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
            </div>
          </div>
        </div>


              <!-- Gallery Modal -->
                <div id="galleryDetailModal" class="modal fade" tabindex="-1" aria-labelledby="galleryDetailModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered" style="max-width: 520px">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title">{{ $t("content.jobId") }} : {{jobId}} </h4>
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                          <i class="material-icons material-symbols-outlined">close</i>
                        </button>
                      </div>
        
                      <div class="modal-body">
                        <div id="galleryImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false">
                          <div class="carousel-indicators">
                            <div class="carousel-indicators" id="demo2">
                            </div>
                          </div>
                          <div class="carousel-inner">
                            <ul className="list-unstyled">
                              <li v-for="(item, index) in images.length" :key="index">
                                <span v-if="index === 0">
                                  <div class="carousel-item active">
                                    <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                                      :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                                  </div>
                                </span>
                                <span v-else>
                                  <div class="carousel-item">
                                    <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                                      :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                                  </div>
                                </span>
                              </li>
                            </ul>
                          </div>
                          <button class="carousel-control-prev" type="button" data-bs-target="#galleryImages"
                            data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                          </button>
                          <button class="carousel-control-next" type="button" data-bs-target="#galleryImages"
                            data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import Modal from 'bootstrap/js/dist/modal';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ref, reactive, computed, inject, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import apexchart from "vue3-apexcharts";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialInput from "@/components/MaterialInput.vue"
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import PieChart from "@/examples/Charts/PieChart.vue";
import TransactionChart from '@/examples/Charts/TransactionChart.vue'
import moment from 'moment'
import ProgressSpinner from 'primevue/progressspinner';
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import { Pie, Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(ArcElement, Tooltip, Legend);


import noImg from "@/assets/img/noimg.png"
import axios from "axios";
import * as st from "@/config/setting.js";


import { useDashboardStore } from '@/stores/dashboard'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useWorkItemStore } from '@/stores/workItem'
import { useCusTypeStore } from '@/stores/custype'
import { useCusShopStore } from '@/stores/cusshop'
import { useWorkCaseStore } from '@/stores/workcase'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDepositStore } from '@/stores/deposit'
import { useTransactionStore } from '@/stores/transaction'
import { useCusLineStore } from '@/stores/cusline'



const storedash = useDashboardStore()
const storeca = useCashAccountStore()
const storew = useWorkItemStore()
const storect = useCusTypeStore()
const storecuss = useCusShopStore()
const storewc = useWorkCaseStore()
const storei = useInterestStore()
const storep = usePaymentGroupStore()
const storedepo = useDepositStore()
const storetr = useTransactionStore()
const storecusline = useCusLineStore()

///// variables
const { t } = useI18n();
const swal = inject("$swal");

const start_date = ref(new Date());
const end_date = ref(new Date());
const sum_pvalue = ref(0);
const sum_mvalue = ref(0);
const sum_painvalue = ref(0);
const sum_inderevalue = ref(0);
const sum_intvalue = ref(0);
const sum_pawncase = ref(0);
const sum_pawnvalue = ref(0);
const sum_redeemcase = ref(0);
const sum_redeemvalue = ref(0);
const num_q01 = ref(0);
const num_q02 = ref(0);
const num_q03 = ref(0);
const num_q04 = ref(0);
const num_pay = ref(0);
const list_q01 = ref([]);
const list_q02 = ref([]);
const list_q03 = ref([]);
const list_q04 = ref([]);
const list_pay = ref([]);
const userq = ref('');
const list_userq = ref([]);
const res_time = ref('');
const viewGraph = ref(true);
const viewInfo = ref(false);

// const images = ref([])
// const images_l = ref([])

const dataInfo = ref({
  pawnValue: 0,
  interestPawnValue: 0,
  incPawnValue: 0,
  decPawnValue: 0,
  redeemPawnValue: 0,
  interestPawnValueMigration: 0,
  incPawnValueMigration: 0,
  decPawnValueMigration: 0,
  interestAmount: 0,
  incInterestAmount: 0,
  decInterestAmount: 0,
  redeemInterestAmount: 0,
  numOfPawn: 0,
  numOfInterest: 0,
  numOfInc: 0,
  numOfDec: 0,
  numOfInterestMigration: 0,
  numOfIncMigration: 0,
  numOfDecMigration: 0,
  numOfRedeem: 0,
  numOfRedeemInterest: 0,
  numOfCustomer: 0,
  numOfWorkCase: 0,
  numOfActiveWorkCase: 0,
  numOfPostponeWorkCase: 0,
  numOfVoidTicket: 0,
  numOfEditAfterComplete: 0,
  pawnAmount: 0,
  incAmount: 0,
  incDiff: 0,
  decAmount: 0,
  decDiff: 0,
  redeemAmount: 0,
  payAmount: 0,
  receiveAmount: 0,
  sumInterest: 0,
  interestAmountMigration: 0,
  interestTotalPayMigration: 0,
  interestTotalReceiveMigration: 0,
  incAmountMigration: 0,
  incTotalPayMigration: 0,
  incTotalReceiveMigration: 0,
  decAmountMigration: 0,
  decTotalPayMigration: 0,
  decTotalReceiveMigration: 0,
  totalPayMigration: 0,
  totalReceiveMigration: 0,
  numOfCancelTicket: 0,
  numOfTerminate: 0,
  numOfOtp: 0,
  numOfOtpMigration: 0,
})
const dataDue = ref({})
const duelist = ref([])
const legendDue = ref([
  {
    hd: computed(() => t("content.amnticketdueactived")),
    vs: Number(0),
    vm: Number(0),
    tx: "text-primary",
    bg: "bg-primary",
  },
  {
    hd: computed(() => t("content.amnticketdued")),
    vs: Number(0),
    vm: Number(0),
    tx: "text-warning",
    bg: "bg-warning",
  },
  // {
  //   hd: computed(() => t("content.amnticketoveractived")),
  //   vs: Number(0),
  //   vm: Number(0),
  //   tx: "text-danger",
  //   bg: "bg-danger",
  // },
  {
    hd: computed(() => t("content.amnticketoverd")),
    vs: Number(0),
    vm: Number(0),
    tx: "text-secondary",
    bg: "bg-secondary",
  },
]);
const allqueuelist = ref([])
const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const shop_detail = ref({})
const reportlist = ref([])
const start_dater = ref(new Date());
const end_dater = ref(new Date());
const totalTicket = ref(0);
const totalInterest = ref(0);
const totalPawnValue = ref(0);

const tranlist = ref([])
const start_datet = ref(new Date());
const end_datet = ref(new Date());

const info_cat = ref('');
const workcaseDetail = ref(null);
const tk_status = ref('');
const int_cal = ref(0);
const paymentE = ref('');
const loading_i = ref(false);
const int_period = ref('');
const dep_ref = ref('');
const bf_changename = ref('');
const af_changename = ref('');


const images = ref([])
const images_l = ref([])
const listinfo = ref([])
const payment_l = ref([])
const coll_l = ref([])
const jobId = ref('');
const promotionDetail = ref(null);
const displayName = ref("");
const normalDetail = ref(null);
const migrationDetail = ref(null);
const outageDetail = ref(null);
const outageMigrationDetail = ref(null);
const lineDetail = ref(null);
const summaryDetail = ref(null);
const graphDataDetail = ref(null);

const optMonths = ref([
  { items: computed(() => t("opts.mon1")), value: 1 },
  { items: computed(() => t("opts.mon2")), value: 2 },
  { items: computed(() => t("opts.mon3")), value: 3 },
  { items: computed(() => t("opts.mon4")), value: 4 },
  { items: computed(() => t("opts.mon5")), value: 5 },
  { items: computed(() => t("opts.mon6")), value: 6 },
  { items: computed(() => t("opts.mon7")), value: 7 },
  { items: computed(() => t("opts.mon8")), value: 8 },
  { items: computed(() => t("opts.mon9")), value: 9 },
  { items: computed(() => t("opts.mon10")), value: 10 },
  { items: computed(() => t("opts.mon11")), value: 11 },
  { items: computed(() => t("opts.mon12")), value: 12 },
])


///// data
const selectInt = ref("รายวัน");
const selectDrawer = ref("drawer1");

const react = reactive({
  byday: 88,
  byweek: 888,
  bymonth: 8888,
  daydone: 102,
  weekdone: 432,
  monthdone: 1543,
  daybaht: 888888.88,
  weekbaht: 8888888.88,
  monthbaht: 88888888.88,
});

const colors = reactive(["#809bce", "#95b8d1", "#b8e0d2", "#d6eadf", "#eac4d5"]);
const colors2 = reactive(["#dfffdd", "#fecac7", "#b8e0d2"]);

const loading = ref(false)

const legendTimes = ref([{
  bg: "bg-pledge",
  hd: computed(() => t("content.actpawn1")),
  dt: Number(0),
},
{
  bg: "bg-interest",
  hd: computed(() => t("content.actpawn2")),
  dt: Number(0),
},
{
  bg: "bg-add-cap",
  hd: computed(() => t("content.actpawn3")),
  dt: Number(0),
},
{
  bg: "bg-reduce-cap",
  hd: computed(() => t("content.actpawn4")),
  dt: Number(0),
},
{
  bg: "bg-redeem",
  hd: computed(() => t("content.actpawn5")),
  dt: Number(0),
},]);

const legendBaht = ref([
  {
    bg: "bg-pledge",
    hd: computed(() => t("content.actpawn1")),
    dt: Number(0)
  },
  {
    bg: "bg-interest",
    hd: computed(() => t("content.actpawn2")),
    dt: Number(0),
  },
  {
    bg: "bg-add-cap",
    hd: computed(() => t("content.actpawn3")),
    dt: Number(0),
  },
  {
    bg: "bg-reduce-cap",
    hd: computed(() => t("content.actpawn4")),
    dt: Number(0),
  },
  {
    bg: "bg-redeem",
    hd: computed(() => t("content.actpawn5")),
    dt: Number(0),
  },
]);

const legendSum = ref([
  {
    bg: "bg-payment",
    hd: computed(() => t("content.amnoutcome")),
    dt: Number(0)
  },
  {
    bg: "bg-receive",
    hd: computed(() => t("content.amnincome")),
    dt: Number(0),
  },
  {
    bg: "bg-interest",
    hd: computed(() => t("content.amninterest")),
    dt: Number(0),
  },
]);

const legendMig = ref([{
  bg: "bg-interest",
  hd: computed(() => t("content.actpawn2")),
  dt: Number(0),
  dt2: Number(0),
},
{
  bg: "bg-add-cap",
  hd: computed(() => t("content.actpawn3")),
  dt: Number(0),
  dt2: Number(0),
},
{
  bg: "bg-reduce-cap",
  hd: computed(() => t("content.actpawn4")),
  dt: Number(0),
  dt2: Number(0),
},]);



const ylabels = reactive([
  t("content.amnincome"),
  t("content.amnoutcome"),
  t("content.amninterest"),
]);

const barColors = reactive([
  "#809bce",
  "#b8e0d2",
  "#d6eadf",
  "#eac4d5",
  "#977ECD",
  "#D0AE95",
  "#B8CCE0",
]);
const bars = reactive({
  series: [
    {
      name: computed(() => t("content.actpawn1")),
      data: [0, 26, 0],
    },
    {
      name: computed(() => t("content.actpawn3")),
      data: [0, 16, 0],
    },
    {
      name: computed(() => t("content.actpawn4")),
      data: [12, 0, 0],
    },
    {
      name: computed(() => t("content.actpawn5")),
      data: [9, 0, 0],
    },
    {
      name: computed(() => t("content.amndeposit")),
      data: [25, 0, 0],
    },
    {
      name: computed(() => t("content.amnwithdraw")),
      data: [0, 10, 0],
    },
    {
      name: computed(() => t("content.amninterest")),
      data: [25, 0, 19],
    },
  ],
  chartOptions: {
    chart: {
      type: "bar",
      height: 200,
      stacked: true,
    },
    colors: barColors,
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: "14px",
              fontWeight: 900,
              colors: barColors,
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      categories: ylabels,
      labels: {
        formatter: function (val) {
          return val + "m";
        },
      },
    },
    yaxis: {
      type: "String",
      title: {
        text: undefined,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + "m";
        },
      },
    },
    fill: {
      opacity: 1,
      colors: barColors,
    },
    legend: {
      position: "top",
      horizontalAlign: "center",
      offsetX: 40,
      fontSize: "14px",
    },
  },
});

const dueDay = reactive([
  {
    hd: computed(() => t("content.amnticketdueactived")),
    vs: 21,
    vm: 24,
    tx: "text-primary",
    bg: "bg-primary",
  },
  {
    hd: computed(() => t("content.amnticketdued")),
    vs: 3,
    vm: 24,
    tx: "text-warning",
    bg: "bg-warning",
  },
  {
    hd: computed(() => t("content.amnticketoveractived")),
    vs: 4,
    vm: 20,
    tx: "text-danger",
    bg: "bg-danger",
  },
  {
    hd: computed(() => t("content.amnticketoverd")),
    vs: 244,
    vm: 786,
    tx: "text-secondary",
    bg: "bg-secondary",
  },
]);

const dueWeek = reactive([
  {
    hd: computed(() => t("content.amnticketdueactivew")),
    vs: 144,
    vm: 167,
    tx: "text-primary",
    bg: "bg-primary",
  },
  {
    hd: computed(() => t("content.amnticketduew")),
    vs: 23,
    vm: 167,
    tx: "text-warning",
    bg: "bg-warning",
  },
  {
    hd: computed(() => t("content.amnticketoveractivew")),
    vs: 42,
    vm: 45,
    tx: "text-danger",
    bg: "bg-danger",
  },
  {
    hd: computed(() => t("content.amnticketoverw")),
    vs: 244,
    vm: 786,
    tx: "text-secondary",
    bg: "bg-secondary",
  },
]);

const dueMonth = reactive([
  {
    hd: computed(() => t("content.amnticketdueactivem")),
    vs: 807,
    vm: 851,
    tx: "text-primary",
    bg: "bg-primary",
  },
  {
    hd: computed(() => t("content.amnticketduem")),
    vs: 44,
    vm: 851,
    tx: "text-warning",
    bg: "bg-warning",
  },
  {
    hd: computed(() => t("content.amnticketoveractivem")),
    vs: 423,
    vm: 425,
    tx: "text-danger",
    bg: "bg-danger",
  },
  {
    hd: computed(() => t("content.amnticketoverm")),
    vs: 879,
    vm: 1456,
    tx: "text-secondary",
    bg: "bg-secondary",
  },
]);

const datatable = reactive([
  {
    no: "1",
    dat: "xx/xx/xxxx xx:xx",
    nam: "xxxxx xxxxxxxxx",
    old: "aaaaa",
    new: "bbbbb",
    biz: "จำนำ",
    ass: "ทองคำ",
    wei: "30.32",
    qty: "5",
    amo: "88,888,888.88",
    int: "8,888.88",
    by: "หลงจู๊ A",
    mob: "xxx-xxx-xxxx",
  },
  {
    no: "2",
    dat: "xx/xx/xxxx xx:xx",
    nam: "xxxxx xxxxxxxxx",
    old: "aaaaa",
    new: "bbbbb",
    biz: "ต่อดอก",
    ass: "เพชร",
    wei: "12.34",
    qty: "2",
    amo: "88,888,888.88",
    int: "8,888.88",
    by: "หลงจู๊ B",
    mob: "xxx-xxx-xxxx",
  },
  {
    no: "3",
    dat: "xx/xx/xxxx xx:xx",
    nam: "xxxxx xxxxxxxxx",
    old: "aaaaa",
    new: "bbbbb",
    biz: "จำนำ",
    ass: "อื่นๆ",
    wei: "30.32",
    qty: "5",
    amo: "88,888,888.88",
    int: "8,888.88",
    by: "หลงจู๊ B",
    mob: "xxx-xxx-xxxx",
  },
  {
    no: "4",
    dat: "xx/xx/xxxx xx:xx",
    nam: "xxxxx xxxxxxxxx",
    old: "aaaaa",
    new: "bbbbb",
    biz: "ไถ่ถอน",
    ass: "ทองคำ",
    wei: "15.63",
    qty: "1",
    amo: "88,888,888.88",
    int: "8,888.88",
    by: "หลงจู๊ A",
    mob: "xxx-xxx-xxxx",
  },
]);

const drawers = reactive([
  {
    hd: computed(() => t("content.amndrawer")),
    id: "sDrawer1",
    vl: "drawer1",
    sc: "text-danger",
    bf: 500000.0,
    vs: 500000.0,
    vm: 2000000.0,
    tx: "text-primary",
    bg: "bg-primary",
    in: 400000.0,
    ou: 1100000.0,
  },
  {
    hd: computed(() => t("content.amndrawer")),
    id: "sDrawer2",
    vl: "drawer2",
    sc: "text-danger",
    bf: 500000.0,
    vs: 700000.0,
    vm: 2000000.0,
    tx: "text-primary",
    bg: "bg-primary",
    in: 400000.0,
    ou: 1100000.0,
  },
  {
    hd: computed(() => t("content.amndrawer")),
    id: "sDrawer3",
    vl: "drawer3",
    sc: "text-danger",
    bf: 500000.0,
    vs: 1700000.0,
    vm: 2000000.0,
    tx: "text-primary",
    bg: "bg-primary",
    in: 400000.0,
    ou: 1100000.0,
  },
  {
    hd: computed(() => t("content.amnsafe")),
    id: "sSafe1",
    vl: "safe1",
    sc: "text-danger",
    bf: 500000.0,
    vs: 6000000.0,
    vm: 24000000.0,
    tx: "text-info",
    bg: "bg-info",
    in: 400000.0,
    ou: 1100000.0,
  },
]);

const banks = reactive([
  {
    hd: computed(() => t("content.amnbankacc")),
    sc: "text-danger",
    bf: 500000.0,
    vs: 1500000.0,
    vm: 2000000.0,
    tx: "text-warning",
    bg: "bg-warning",
    in: 400000.0,
    ou: 1100000.0,
  },
  {
    hd: computed(() => t("content.amnbankacc")),
    sc: "text-danger",
    bf: 500000.0,
    vs: 1700000.0,
    vm: 2000000.0,
    tx: "text-warning",
    bg: "bg-warning",
    in: 400000.0,
    ou: 1100000.0,
  },
  {
    hd: computed(() => t("content.amnbankacc")),
    sc: "text-danger",
    bf: 500000.0,
    vs: 900000.0,
    vm: 2000000.0,
    tx: "text-warning",
    bg: "bg-warning",
    in: 400000.0,
    ou: 1100000.0,
  },
]);

const detailDrawer = reactive([
  {
    hd: "1000",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-primary",
  },
  {
    hd: "500",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-primary",
  },
  {
    hd: "100",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-primary",
  },
  {
    hd: "50",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-primary",
  },
  {
    hd: "20",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-primary",
  },
  {
    hd: "10",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-primary",
  },
  {
    hd: "5",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-primary",
  },
  {
    hd: "1",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-primary",
  },
  {
    hd: computed(() => t("content.amntotaltransact")),
    cr: computed(() => t("content.amntotbaht")),
    vs: 1400000,
    vm: 2000000,
    tx: "text-primary",
  },
]);

const detailSafe = reactive([
  {
    hd: "1000",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-info",
  },
  {
    hd: "500",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-info",
  },
  {
    hd: "100",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-info",
  },
  {
    hd: "50",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-info",
  },
  {
    hd: "20",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-info",
  },
  {
    hd: "10",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-info",
  },
  {
    hd: "5",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-info",
  },
  {
    hd: "1",
    cr: computed(() => t("content.curency")),
    vs: 14,
    vm: 1000,
    tx: "text-info",
  },
  {
    hd: computed(() => t("content.amntotaltransact")),
    cr: computed(() => t("content.amntotbaht")),
    vs: 1800000,
    vm: 2000000,
    tx: "text-info",
  },
]);

const custypeList = ref([])
const cusShop = ref({
  uid: '',
  cusUid: "",
  shopUid: "",
  cusTypeUid: "0",
  interestUid: "no",
  openAccountDate: null,
  lastActiveDate: null,
  phoneNo1: "",
  phoneNo2: "",
  phoneNo3: "",
  signature1Uid: "0",
  signature2Uid: "0",
  fingerPrint1Uid: "0",
  fingerPrint2Uid: "0",
  fgTemplate1Uid: "0",
  fgTemplate2Uid: "0",
  email: "",
  warningMsg: "",
  notifyWarning: false,
  creditAmount: 0,
  version: '0',
  cusName: "",
})


const stats = ref([
  {
    label: 'ยอดตั๋วจํานํา (เข้า)',
    value: 0.00,
    subPrefix: 'จำนวน:',
    subText: '',
    subUnit: 'เบอร์',
    icon: 'fas fa-hand-holding-heart',
    type: 'pawn-in'
  },
  {
    label: 'ยอดตั๋วไถ่ถอน (ออก)',
    value: 0.00,
    subPrefix: 'จำนวน:',
    subText: '',
    subUnit: 'เบอร์',
    icon: 'fas fa-hand-holding-usd',
    type: 'pawn-out'
  },
  {
    label: 'รายได้ดอกเบี้ยรวม',
    value: 0.00,
    subPrefix: '',
    subText: '',
    subUnit: '',
    icon: 'fas fa-coins',
    type: 'interest'
  },
  {
    label: 'เงินสุทธิวันนี้ (เพิ่มขึ้น)',
    value: 0.00,
    subPrefix: 'สต๊อคสุทธิ:',
    subText: '',
    subUnit: 'รายการ',
    isRed: true,
    icon: 'fas fa-chart-line',
    type: 'net-cash'
  }
])

// ข้อมูลสำหรับ กราฟยอดตั๋วจํานำ
const pawnData = ref({
  labels: ['จํานำ', 'ต่อดอก', 'เพิ่มต้น', 'ลดต้น'],
  datasets: [{
    data: [0, 0, 0, 0],
    backgroundColor: ['#3b82f6', '#f97316', '#84cc16', '#ef4444'],
    borderWidth: 0,
  }]
});

// ข้อมูลสำหรับ กราฟยอดตั๋วไถ่ถอน
const redeemData = ref({
  labels: ['ไถ่ถอน', 'ต่อดอก', 'เพิ่มต้น', 'ลดต้น'],
  datasets: [{
    data: [0, 0, 0, 0],
    backgroundColor: ['#FDDA0D', '#f97316', '#84cc16', '#ef4444'],
    borderWidth: 0,
  }]
});

// ข้อมูลสำหรับ สัดส่วนรายได้ดอกเบี้ย (Doughnut)
const interestData = ref({
  labels: ['ดอกเบี้ยเพิ่มต้น', 'ดอกเบี้ยไถ่ถอน','ดอกเบี้ยต่อดอก'],
  datasets: [{
    data: [0, 0, 0],
    backgroundColor: ['#3b82f6','#1e3a8a', '#7dd3fc'],
    cutout: '50%',
    borderWidth: 0,
    lb: ['ดอกเบี้ยเพิ่มต้น', 'ดอกเบี้ยไถ่ถอน','ดอกเบี้ยต่อดอก'],
  }]
});

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    datalabels: {
      clamp: true,     // บังคับให้อยู่ภายในพื้นที่กราฟ
      overlap: false,  // สั่งให้ Plugin พยายามซ่อนตัวที่ทับกัน (ไม่การันตี 100% แต่ช่วยได้)
      anchor: 'end',    // ให้ตัวเลขไปเกาะที่ขอบนอกของชิ้นเค้ก
      align: 'start',   // จัดวางตัวเลขให้หันเข้าหาจุดศูนย์กลาง (หรือใช้ 'end' เพื่อให้ออกไปนอกวง)
      offset: 10,       // ระยะห่างจากจุด anchor
      padding: 4,       // เพิ่มช่องว่างรอบตัวเลข
      color: '#ffffff',
      font: {
        weight: 'bold',
        size: 12
      },
      display: (context) => {
        const dataset = context.dataset;
        const value = dataset.data[context.dataIndex];
        const total = dataset.data.reduce((acc, curr) => acc + curr, 0);
        const percentage = (value / total) * 100;

        // แสดงเฉพาะชิ้นที่มีค่ามากกว่า 5% เท่านั้น (ปรับตัวเลขได้ตามชอบ)
        return percentage > 0; 
      },
      formatter: (value, ctx) => {
        // 1. หาผลรวมทั้งหมดของ data ใน dataset นี้
        let sum = 0;
        let dataArr = ctx.chart.data.datasets[0].data;
        dataArr.map(data => {
          sum += data;
        });
        
        // 2. คำนวณหา % และปัดเศษทศนิยม
        let percentage = (value * 100 / sum).toFixed(1) + "%";
        return percentage;
      },
    }
  }
};

const simpleOptions = {
  plugins: {
    tooltip: {
      callbacks: {
        label: (context) => {
          const dataset = context.dataset;
          const total = dataset.data.reduce((acc, curr) => acc + curr, 0);
          const value = dataset.data[context.dataIndex];
          const percentage = ((value / total) * 100).toFixed(1) + '%';
          return `${context.label}: ${percentage}`;
        }
      }
    },
    // มั่นใจว่าลบ datalabels: { ... } ออกจากที่นี่แล้ว
  }
};


///// computed
const plegde = computed(() => t("content.actpawn1"));
const interest = computed(() => t("content.actpawn2"));
const addcap = computed(() => t("content.actpawn3"));
const reducecap = computed(() => t("content.actpawn4"));
const redeem = computed(() => t("content.actpawn5"));
const cancel = computed(() => t("buttons.canc"));
const search = computed(() => t("buttons.sear"));
const sinterest = computed(() => t("content.amninterest"));
const sincome = computed(() => t("content.amnincome"));
const soutcome = computed(() => t("content.amnoutcome"));

///// methods
const calPercent = (val, full) => {
  return (parseInt(val) * 100) / parseInt(full);
};

const fmNumber = (val) => {
  return Intl.NumberFormat("en-US").format(val);
};

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

const onClickHandler = (page) => {
  updatePagination()
};


const getshopInfo = async (val) => {
  shop_detail.value = {}
  const response = await storeca.cashaccountInfoFromSessionFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log("shop_detail : " + JSON.stringify(response.data.data));
        shop_detail.value = response.data.data
        await loadDataInfoApi()
        loadAllQueueApi()
        loadDataDueApi()
        loadDueListApi()
        loadCusTypeListApi()
        loadPaymentAllApi()
      }
    }
  }
}

getshopInfo()

const loadDataInfoApi = async () => {
  res_time.value = ''
  dataInfo.value.pawnValue = 0
  dataInfo.value.interestPawnValue = 0
  dataInfo.value.incPawnValue = 0
  dataInfo.value.decPawnValue = 0
  dataInfo.value.redeemPawnValue = 0
  dataInfo.value.interestAmount = 0
  dataInfo.value.incInterestAmount = 0
  dataInfo.value.decInterestAmount = 0
  dataInfo.value.redeemInterestAmount = 0
  dataInfo.value.numOfPawn = 0
  dataInfo.value.numOfInterest = 0
  dataInfo.value.numOfInc = 0
  dataInfo.value.numOfDec = 0
  dataInfo.value.numOfInterestMigration = 0
  dataInfo.value.numOfIncMigration = 0
  dataInfo.value.numOfDecMigration = 0
  dataInfo.value.numOfRedeem = 0
  dataInfo.value.numOfRedeemInterest = 0
  dataInfo.value.numOfCustomer = 0
  dataInfo.value.numOfWorkCase = 0
  dataInfo.value.numOfActiveWorkCase = 0
  dataInfo.value.numOfPostponeWorkCase = 0
  dataInfo.value.numOfVoidTicket = 0
  dataInfo.value.numOfEditAfterComplete = 0
  dataInfo.value.pawnAmount = 0
  dataInfo.value.incAmount = 0
  dataInfo.value.incDiff = 0
  dataInfo.value.decAmount = 0
  dataInfo.value.decDiff = 0
  dataInfo.value.redeemAmount = 0
  dataInfo.value.payAmount = 0
  dataInfo.value.receiveAmount = 0
  dataInfo.value.sumInterest = 0
  dataInfo.value.interestAmountMigration = 0
  dataInfo.value.interestTotalPayMigration = 0
  dataInfo.value.interestTotalReceiveMigration = 0
  dataInfo.value.incAmountMigration = 0
  dataInfo.value.incTotalPayMigration = 0
  dataInfo.value.incTotalReceiveMigration = 0
  dataInfo.value.decAmountMigration = 0
  dataInfo.value.decTotalPayMigration = 0
  dataInfo.value.decTotalReceiveMigration = 0
  dataInfo.value.totalPayMigration = 0
  dataInfo.value.totalReceiveMigration = 0
  dataInfo.value.numOfCancelTicket = 0
  dataInfo.value.numOfTerminate = 0
  dataInfo.value.numOfOtp = 0
  dataInfo.value.numOfOtpMigration = 0
  sum_pvalue.value = 0
  sum_mvalue.value = 0;
  sum_painvalue.value = 0;
  sum_inderevalue.value = 0;
  sum_intvalue.value = 0;
  sum_pawncase.value = 0;
  sum_pawnvalue.value = 0;
  sum_redeemcase.value = 0;
  sum_redeemvalue.value = 0;
  loading.value = false
  let data = "";
  data = {
    fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDT23:59:59'),
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  const response = await storedash.dashboardInfoFetch(payload);
  // console.log('dataInfo : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res_time.value = moment(String(new Date)).local().format('HH:mm:ss')
        dataInfo.value = response.data.data;
        setnumOfTransaction()
        setnumOfAmount()
        setnumOfSum()
        setnumOfMig()
        sum_pvalue.value = dataInfo.value.pawnValue + dataInfo.value.interestPawnValue + dataInfo.value.incPawnValue
          + dataInfo.value.decPawnValue + dataInfo.value.redeemPawnValue;
        sum_mvalue.value = dataInfo.value.interestPawnValueMigration + dataInfo.value.incPawnValueMigration
          + dataInfo.value.decPawnValueMigration;
        sum_painvalue.value = dataInfo.value.pawnValue + dataInfo.value.incPawnValue
        sum_inderevalue.value = dataInfo.value.interestPawnValue + dataInfo.value.decPawnValue + dataInfo.value.redeemPawnValue;
        sum_intvalue.value = dataInfo.value.interestAmount + dataInfo.value.incInterestAmount + dataInfo.value.decInterestAmount
          + dataInfo.value.redeemInterestAmount;
        sum_pawncase.value = Number(dataInfo.value.numOfPawn) + Number(dataInfo.value.numOfInterest) + Number(dataInfo.value.numOfInc) + Number(dataInfo.value.numOfDec)
          + Number(dataInfo.value.numOfInterestMigration) + Number(dataInfo.value.numOfIncMigration) + Number(dataInfo.value.numOfDecMigration);
        sum_pawnvalue.value = dataInfo.value.pawnValue + dataInfo.value.interestPawnValue + dataInfo.value.incPawnValue
          + dataInfo.value.decPawnValue + sum_mvalue.value;
        sum_redeemcase.value = Number(dataInfo.value.numOfInterest) + Number(dataInfo.value.numOfInc) + Number(dataInfo.value.numOfDec) + Number(dataInfo.value.numOfRedeem);
        sum_redeemvalue.value = dataInfo.value.interestPawnValue + (dataInfo.value.incPawnValue - dataInfo.value.incDiff)
          + (dataInfo.value.decPawnValue + dataInfo.value.decDiff) + dataInfo.value.redeemPawnValue;
        setnumOfGraph()  
        loading.value = true
      }
    }
  }

}

const loadCusTypeListApi = async (val) => {
  let data = "";
  data = {
    index: 0,
    size: 100,
    name: "",
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storect.custypeListFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        custypeList.value = response.data.data.list;
      }
    }
  }
}

const loadDataDueApi = async () => {
  let data = "";
  data = {
    dueDate: moment(new Date()).format('YYYY-MM-DDT00:00:00'),
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storedash.dashboardDueFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        dataDue.value = response.data.data;
        setseriesDue()
      }
    }
  }

}

const loadDueListApi = async () => {
  currentPage.value = 1
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    lastOpenDate: moment(new Date(shop_detail.value.lastOpenDate)).format('YYYY-MM-DDT00:00:00'),
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  const response = await storedash.overdueListFetch(payload);
  // console.log('DueListApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        duelist.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        // console.log('dataInfo : ' + JSON.stringify(dataInfo.value))
      }
    }
  }
}

async function updatePagination() {
  duelist.value = []
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    lastOpenDate: moment(new Date(shop_detail.value.lastOpenDate)).format('YYYY-MM-DDT00:00:00'),
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  const response = await storedash.overdueListFetch(payload);
  // console.log('loadDueListApi : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        duelist.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        // console.log('dataInfo : ' + JSON.stringify(dataInfo.value))
      }
    }
  }
}


const loadAllQueueApi = async () => {
  allqueuelist.value = []
  num_q01.value = 0
  num_q02.value = 0
  num_q03.value = 0
  num_q04.value = 0
  num_pay.value = 0
  list_q01.value = []
  list_q02.value = []
  list_q03.value = []
  list_q04.value = []


  let data = "";
  data = {
    index: '0',
    size: '100',
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,

  };
  const payload = data;
  const response = await storew.listAllQueueFetch(payload);
  // console.log('loadAllQueueApi : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        allqueuelist.value = response.data.data.list;

        list_q01.value = allqueuelist.value.filter((c) => c.queue !== null && c.queue.code === 'Q01');
        num_q01.value = list_q01.value.length

        list_q02.value = allqueuelist.value.filter((c) => c.queue !== null && c.queue.code === 'Q02');
        num_q02.value = list_q02.value.length

        list_q03.value = allqueuelist.value.filter((c) => c.queue !== null && c.queue.code === 'Q03');
        num_q03.value = list_q03.value.length


        list_q04.value = allqueuelist.value.filter((c) => c.queue !== null && c.queue.code === 'Q04');
        num_q04.value = list_q04.value.length

      }
    }
  }

}

async function searchCustomer(item) {
  // console.log('cusUid : ' + item.cusUid)
  await clearCustomer()
  let data = "";
  data = {
    uid: item.cusUid,
  };

  const payload = data;
  const response = await storecuss.cusShopInfoByCusUidFetch(payload);
  // console.log("CusshopInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        if (response.data.data !== null) {
          cusShop.value = response.data.data
          cusShop.value.cusName = item.cusName
          await getCustomerLineInfo(cusShop.value.cusUid)
          document.getElementById("exampleModalShow").click();
        }
      }
    }
  }
}

async function clearCustomer() {
  cusShop.value = {
    uid: '',
    cusUid: "",
    shopUid: "",
    cusTypeUid: "0",
    interestUid: "no",
    openAccountDate: null,
    lastActiveDate: null,
    phoneNo1: "",
    phoneNo2: "",
    phoneNo3: "",
    signature1Uid: "0",
    signature2Uid: "0",
    fingerPrint1Uid: "0",
    fingerPrint2Uid: "0",
    fgTemplate1Uid: "0",
    fgTemplate2Uid: "0",
    email: "",
    warningMsg: "",
    notifyWarning: false,
    creditAmount: 0,
    version: '',
    cusName: "",
  }
}


function cancelBtn() {
  start_date.value = new Date();
  end_date.value = new Date();
  dataInfo.value = {}
}

// ฟังก์ชันสำหรับเช็คว่าเป็นตัวเลขบวกและเป็นประเภท net-cash หรือไม่
const isPositiveNetCash = (item) => {
  return item.type === 'net-cash' && item.value > 0
}

const getStatusText = (item) => {
  if (item.type !== 'net-cash') return ''
  
  const value = parseFloat(item.value)
  if (value > 0) return '(เพิ่มขึ้น)'
  if (value < 0) return '(ลดลง)'
  
  return '' // หรือ return '(คงที่)' หากต้องการให้แสดงข้อความเมื่อเป็น 0
}

function changeViewGraph() { 
  if (viewGraph.value) {
    viewInfo.value = false
  } else {
    viewInfo.value = true
  }

}


function changeViewInfo() { 
  if (viewInfo.value) {
    viewGraph.value = false
  } else {
    viewGraph.value = true
  }

}

function monthDiff() {
  let pro = false
  var months;
  months = (end_date.value.getFullYear() - start_date.value.getFullYear()) * 12;
  months += end_date.value.getMonth() - start_date.value.getMonth();

  if (months > 3) {
    pro = true
  }
  return pro
}

async function setnumOfTransaction() {

  legendTimes.value = [
    {
      bg: "bg-pledge",
      hd: computed(() => t("content.actpawn1")),
      dt: Number(dataInfo.value.numOfPawn),
    },
    {
      bg: "bg-interest",
      hd: computed(() => t("content.actpawn2")),
      dt: Number(dataInfo.value.numOfInterest),
    },
    {
      bg: "bg-add-cap",
      hd: computed(() => t("content.actpawn3")),
      dt: Number(dataInfo.value.numOfInc),
    },
    {
      bg: "bg-reduce-cap",
      hd: computed(() => t("content.actpawn4")),
      dt: Number(dataInfo.value.numOfDec),
    },
    {
      bg: "bg-redeem",
      hd: computed(() => t("content.actpawn5")),
      dt: Number(dataInfo.value.numOfRedeem),
    },
  ];


}

async function setnumOfAmount() {
  legendBaht.value = [
    {
      bg: "bg-pledge",
      hd: computed(() => t("content.actpawn1")),
      dt: Number(dataInfo.value.pawnAmount)
    },
    {
      bg: "bg-interest",
      hd: computed(() => t("content.actpawn2")),
      dt: Number(dataInfo.value.interestAmount),
    },
    {
      bg: "bg-add-cap",
      hd: computed(() => t("content.actpawn3")),
      dt: Number(dataInfo.value.incAmount),
    },
    {
      bg: "bg-reduce-cap",
      hd: computed(() => t("content.actpawn4")),
      dt: Number(dataInfo.value.decAmount),
    },
    {
      bg: "bg-redeem",
      hd: computed(() => t("content.actpawn5")),
      dt: Number(dataInfo.value.redeemAmount),
    },
  ];
}

async function setnumOfSum() {

  legendSum.value = [
    {
      bg: "bg-payment",
      hd: computed(() => t("content.amnoutcome")),
      dt: Number(dataInfo.value.pawnAmount) + Number(dataInfo.value.incAmount)
    },
    {
      bg: "bg-receive",
      hd: computed(() => t("content.amnincome")),
      dt: Number(dataInfo.value.decAmount) + Number(dataInfo.value.redeemAmount) + Number(dataInfo.value.interestAmount)
    },
    {
      bg: "bg-interest",
      hd: computed(() => t("content.amninterest")),
      dt: Number(dataInfo.value.sumInterest),
    },

  ];

}

async function setnumOfMig() {

  legendMig.value = [
    {
      bg: "bg-interest",
      hd: computed(() => t("content.actpawn2")),
      dt: Number(dataInfo.value.interestAmountMigration),
      dt2: Number(dataInfo.value.numOfInterestMigration),
    },
    {
      bg: "bg-add-cap",
      hd: computed(() => t("content.actpawn3")),
      dt: Number(dataInfo.value.incAmountMigration),
      dt2: Number(dataInfo.value.numOfIncMigration),
    },
    {
      bg: "bg-reduce-cap",
      hd: computed(() => t("content.actpawn4")),
      dt: Number(dataInfo.value.decAmountMigration),
      dt2: Number(dataInfo.value.numOfDecMigration),
    },

  ];

}

async function setseriesDue() {
  let totaldue = Number(dataDue.value.clearToday) + Number(dataDue.value.notClearToday)
  legendDue.value = [
    {
      hd: computed(() => t("content.amnticketdueactived")),
      vs: Number(dataDue.value.clearToday),
      vm: Number(totaldue),
      tx: "text-primary",
      bg: "bg-primary",
    },
    {
      hd: computed(() => t("content.amnticketdued")),
      vs: Number(dataDue.value.notClearToday),
      vm: Number(totaldue),
      tx: "text-warning",
      bg: "bg-warning",
    },
    // {
    //   hd: computed(() => t("content.amnticketoveractived")),
    //   vs: Number(dataDue.value.overdue),
    //   vm: Number(dataDue.value.overdueTotal),
    //   tx: "text-danger",
    //   bg: "bg-danger",
    // },
    {
      hd: computed(() => t("content.amnticketoverd")),
      vs: Number(dataDue.value.overdueClearToday),
      vm: Number(dataDue.value.overdueCount),
      tx: "text-secondary",
      bg: "bg-secondary",
    },
  ];

}


async function setnumOfGraph() {
  let sub_case = Number(sum_pawncase.value)-Number(sum_redeemcase.value)
  let sub_val =  Number(sum_redeemvalue.value) - Number(sum_pawnvalue.value)
  let red  = false
  if (sub_case < 0) {
    red = true
  }

  stats.value = [
  {
    label: 'ยอดตั๋วจํานํา (เข้า)', 
    value: sum_pawnvalue.value,
    subPrefix: 'จำนวน:',
    subText: formatNumberString(sum_pawncase.value),
    subUnit: 'เบอร์',
    icon: 'fas fa-hand-holding-heart',
    type: 'pawn-in'
  },
  {
    label: 'ยอดตั๋วไถ่ถอน (ออก)',
    value: sum_redeemvalue.value,
    subPrefix: 'จำนวน:',
    subText: formatNumberString(sum_redeemcase.value),
    subUnit: 'เบอร์',
    icon: 'fas fa-hand-holding-usd',
    type: 'pawn-out'
  },
  {
    label: 'รายได้ดอกเบี้ยรวม',
    value: sum_intvalue.value,
    subPrefix: '',
    subText: '',
    subUnit: '',
    icon: 'fas fa-coins',
    type: 'interest'
  },
  {
    label: 'เงินสุทธิวันนี้',
    value: sub_val,
    subPrefix: 'สต๊อกสุทธิ:',
    subText: formatNumberString(sub_case),
    subUnit: 'รายการ',
    isRed: red,
    icon: 'fas fa-chart-line',
    type: 'net-cash'
  }
]


let tt_pawn = Number(sum_mvalue.value)+Number(dataInfo.value.pawnValue)

pawnData.value = {
  labels: ['จํานำ', 'ต่อดอก', 'เพิ่มต้น', 'ลดต้น'],
  datasets: [{
    data: [tt_pawn, dataInfo.value.interestPawnValue, dataInfo.value.incPawnValue, dataInfo.value.decPawnValue],
    backgroundColor: ['#3b82f6', '#f97316', '#84cc16', '#ef4444'],
    borderWidth: 1,
  },
  ]
}


// ข้อมูลสำหรับ กราฟยอดตั๋วไถ่ถอน
redeemData.value = {
  labels: ['ไถ่ถอน', 'ต่อดอก', 'เพิ่มต้น', 'ลดต้น'],
  datasets: [{
    data: [dataInfo.value.redeemPawnValue, dataInfo.value.interestPawnValue, dataInfo.value.incPawnValue, dataInfo.value.decPawnValue],
    backgroundColor: ['#DAA520', '#f97316', '#84cc16', '#ef4444'],
    borderWidth:1,
  }]
};

// ข้อมูลสำหรับ สัดส่วนรายได้ดอกเบี้ย (Doughnut)
  interestData.value = {
  labels: ['ดอกเบี้ยเพิ่มต้น', 'ดอกเบี้ยไถ่ถอน','ดอกเบี้ยต่อดอก','ดอกเบี้ยลดต้น'],  
  datasets: [{
    data: [dataInfo.value.incInterestAmount, dataInfo.value.redeemInterestAmount, dataInfo.value.interestAmount , dataInfo.value.decInterestAmount],
    backgroundColor: ['#84cc16', '#DAA520', '#f97316' , '#ef4444'],
    cutout: '50%',
    borderWidth: 1,
    lb: ['ดอกเบี้ยเพิ่มต้น', 'ดอกเบี้ยไถ่ถอน','ดอกเบี้ยต่อดอก','ดอกเบี้ยลดต้น'],
  }]
};

}


function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatDecimalString(num) {
  num = Number(num)
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberString(num) {
  num = Number(num)
  if (num === null || num === undefined) {
    num = 0
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );

}

function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}


function format_time(value) {
  if (value) {
    return moment(String(value)).local().format('HH:mm:ss')
  }
}



function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }else if (str === 'PAYMENT') {
    side = 'การชำระ'
  }else if (str === 'REVIEW_COLLATERAL') {
      side = 'ขอดูทรัพย์'
  }
  return side
}


function checkTransaction2(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอก'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }else if (str === 'PAYMENT') {
    side = 'การชำระ'
  }else if (str === 'REVIEW_COLLATERAL') {
      side = 'ขอดูทรัพย์'
  }
  return side
}


async function onClickTab(val) {
  if (val === '1') {
    if (!monthDiff() && start_date.value <= end_date.value) {
      await loadDataInfoApi()
    }
    await setfirstTab()
  } else if (val === '2') {
    if (start_dater.value <= end_dater.value) {
      await loadRedeemReportApi()
    }
    await setsecondTab()
  }else if (val === '3') {
    if (start_datet.value <= end_datet.value) {
      await searchTransactionsInfo()
    }
    await setthirdTab()
  }
}


async function setfirstTab() {
  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
}


async function setsecondTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.add('show', 'active')
  }
}

async function setthirdTab() {
  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.add('show', 'active')
  }
}


const loadRedeemReportApi = async () => {
  totalTicket.value = 0;
  totalInterest.value = 0;
  totalPawnValue.value = 0;
  let data = "";
  data = {
    fromDate: moment(new Date(start_dater.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_dater.value)).format('YYYY-MM-DDT23:59:59'),
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  const response = await storedash.redeemReportFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        reportlist.value = response.data.data.list;
        totalTicket.value = response.data.data.ext.totalTicket;
        totalInterest.value = response.data.data.ext.totalInterest;
        totalPawnValue.value = response.data.data.ext.totalPawnValue;

      }
    }
  }
}


const loadPaymentAllApi = async () => {
  list_pay.value = []
  let data = "";
  data = {
    index: 0,
    size: 100,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  const response = await storedash.listPaymentAllFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list_pay.value = response.data.data.list;
        num_pay.value = list_pay.value.length
      }
    }
  }
}

function filterUserOwner(str) {
  let ld = allqueuelist.value.filter((c) => c.uid === str && c.type === 'PAYMENT')
  // console.log('filterUserOwner : ' + JSON.stringify(ld))
  let name = ''
  if (ld.length > 0) {
    name = ld[0].ownerName
  }
  return name
}


function filterMonths(str) {
  let side = ''
  let name = optMonths.value.filter((c) => c.value === str);
  if (name.length > 0) {
    side = name[0].items
  }
  return side
}

function setyears(year) {
  return Number(year) + 543
}

function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const NewTab = async () => {
  sessionStorage.removeItem('deferWorkcaseUid');
  sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
  if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
    const win = window.open("#/generals/defer_items", "_blank");
    win.focus();
    sessionStorage.removeItem('deferWorkcaseUid');
  }
}


const goToRpDefer = async () => {
  sessionStorage.removeItem('deferReport');
  sessionStorage.setItem("deferReport", true);
  return window.location.assign("#/reports/report_defer");
}


const goToRpProfit = async () => {
  return window.location.assign("#/reports/report_profit");
}


const goToHistory = async (val) => {
  let data = {
    start_date: moment(new Date(start_date.value)).format('YYYY-MM-DDT00:00:00'),
    end_date: moment(new Date(end_date.value)).format('YYYY-MM-DDT23:59:59'),
    value: val
  }
  sessionStorage.removeItem('historyPage');
  sessionStorage.setItem("historyPage", JSON.stringify(data));
  return window.location.assign("#/generals/history");
}

const goToHistory_detail = async (val,channel,type) => {
  let data = {
    start_date: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    end_date: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
    value: val,
    type: type,
    channel: channel
  }
  sessionStorage.removeItem('historyPage');
  sessionStorage.setItem("historyPage", JSON.stringify(data));
  return window.location.assign("#/generals/history");
}

async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  info_cat.value = ''
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  promotionDetail.value = null

  await getworkCaseInfo(item.refNumber)
  if (workcaseDetail.value != null) {
    // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
    if (workcaseDetail.value.changeName) {
      af_changename.value = workcaseDetail.value.tkCustomerInfo.name 
      await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }
    if (workcaseDetail.value.deposit) {
      await getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    await detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals
    await calIntInt();
    if (workcaseDetail.value.transactionType !== 'REDEEM') {

      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }

    if (workcaseDetail.value.promotionUid !== '0') { 
          await retrieveInfo(workcaseDetail.value)
    }

    if (images_l.value.length > 0) {
      getTicketImage()
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      setGallery()
      document.getElementById("detailModal").click();
    }
  }
}

function setGallery() {

  var i, y = "";

  for (i = 0; i < images.value.length; i++) {
    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo1").innerHTML = y;
}


async function getworkCaseInfo(id) {
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: id,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}

async function calIntInt() {
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }
  data = {
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod
      }
    }
  }
}

async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    uid: item,
  };
  const payload = data;
  const response = await storep.paymentGroupinfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}


function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}


async function getTicketImage() {
  if (images.value.length === 0) {
    let url = []
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      if (images_l.value[i].imageUid !== "0") {
        url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
      }
    }
    if (url.length > 0) {
      await getFile(url)
      if (images.value.length > 0) {
        setGallery()
        document.getElementById("detailModal").click();

      } else {
        let obj = {
          src: noImg,
          thumbnailImageSrc: noImg,
          alt: '',
          title: ''
        }
        images.value.push(obj)
        setGallery()
        document.getElementById("detailModal").click();

      }
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      setGallery()
      document.getElementById("detailModal").click();
    }
  } else {
    setGallery()
    document.getElementById("detailModal").click();
  }
}


async function getFile(urls) {
  let file_L = []
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
  const requests = urls.map((url) => axios.get(url));
  await Promise.all(requests).then(allResults => {
    if (allResults) {
      file_L = allResults
      if (file_L !== null) {
        for (let i = 0; i < file_L.length; i++) {
          // console.log('file_L : ' + JSON.stringify(file_L[i].data));
          if (file_L[i].data.data !== null) {
            const file = getFileFromBase64(file_L[i].data.data.data, file_L[i].data.data.name)
            const data = URL.createObjectURL(file);
            let obj = {
              src: data,
              thumbnailImageSrc: data,
              alt: '',
              title: ''
            }
            images.value.push(obj)
          }
        }
      }
    }
  })
}

function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function viewUserWorkDetail(val) {
  userq.value = val
  list_userq.value = []
  if (userq.value === 'Q01') {
    list_userq.value = list_q01.value
  } else if (userq.value === 'Q02') {
    list_userq.value = list_q02.value
  } else if (userq.value === 'Q03') {
    list_userq.value = list_q03.value
  } else if (userq.value === 'Q04') {
    list_userq.value = list_q04.value
  } else if (userq.value === 'QPAY') {
    list_userq.value = list_pay.value
  }

  document.getElementById("userWorkModalShow").click();
}

async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}


async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name 
      }
    }
  }
}

async function getCollecteral(uid , val) {
  coll_l.value = []
  let detail = null
  let data = {
    uid: uid,
  };
  const payload = data;
  const response = await storewc.workCaseinfoFetch(payload);
  // console.log("getwc : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        detail = response.data.data
        if (val === 'coll') {
          const items1 = [];  
        
        if (detail.ticket.collaterals.length > 0) {
          for (var i = 0; i < detail.ticket.collaterals.length; i++) {
            items1.push(detail.ticket.collaterals[i].remark);
          }

          swal({
            title: 'ข้อมูลรายละเอียดทรัพย์',
            text: '',
            icon: '',
            width: 900, // Accepts a number (pixels)
            html: ` <pre></pre> 
                    <ol style="text-align: left;">
                      <pre></pre> 
                      ${items1.map(item => `<li>${item}</li>`).join('')}
                      <pre></pre> 
                    </ol>
                    <pre></pre> 
                  `,
            target: '#detailUserWorkModal',
            customClass: {
              container: 'loading-state'
            },
          })
        } else {
          swal({
            title: 'ไม่มีข้อมูลรายละเอียดทรัพย์',
            text: '',
            icon: 'warning',
            button: t('button.confirm'),
            target: '#detailUserWorkModal',
            customClass: {
              container: 'loading-state'
            },
          })
        } 
          
      }else if(val === 'img'){
          jobId.value = detail.workItems[0].jobId
          images.value = []
          images_l.value = []
          images_l.value = detail.ticket.images
          if(images_l.value.length > 0){
            openGallery()
          }else {
            swal({
              title: 'ไม่มีข้อมูลรูปทรัพย์',
              text: '',
              icon: 'warning',
              button: t('button.confirm'),
              target: '#detailUserWorkModal',
              customClass: {
                container: 'loading-state'
              },
            })
          }
        }
      }
    }
  }
}


async function openGallery() {
  if (images.value.length === 0) {
    loading_i.value = true
    let url = []
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      if (images_l.value[i].imageUid !== "0") {
        url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
      }
    }

    if (url.length > 0) {
      await getFile(url)
      if (images.value.length > 0) {
        setGalleryModal()
        loading_i.value = false
        const myModal = document.getElementById('galleryDetailModal');
        const modal = new Modal(myModal); // Instantiates your modal
        modal.show();
      }
    }

  } else {
    setGalleryModal()
    loading_i.value = false
    const myModal = document.getElementById('galleryDetailModal');
    const modal = new Modal(myModal); // Instantiates your modal
    modal.show();
  }
}


function setGalleryModal() {

  var i, y = "";

  for (i = 0; i < images.value.length; i++) {

    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#galleryImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#galleryImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo2").innerHTML = y;
}


async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }
  data = {
    cusUid : item.customerInfo.customerUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}


async function getCustomerLineInfo(uid) {
  displayName.value = ''
  let data = "";
  data = {
    index: 0,
    size: 10,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    cusUid: uid,
  };

  const payload = data;
  // console.log("CustomerInfo p : " + JSON.stringify(payload));
  const response = await storecusline.cusLineListFetch(payload);
  // console.log("CustomerInfo r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let list = response.data.data.list
        if (list.length > 0) {
          displayName.value = response.data.data.list[0].displayName
        }
      }
    }
  }
}

async function searchTransactionsInfo() {
  tranlist.value = []
  normalDetail.value = null
  migrationDetail.value = null
  outageDetail.value = null
  outageMigrationDetail.value = null
  lineDetail.value = null
  summaryDetail.value = null
  graphDataDetail.value = null

  await getNormalInfo()
  await getMigrationInfo()
  await getOutageInfo()
  await getOutageMigrationInfo()
  await getLineInfo()
  await getSummaryInfo()
  await getGraphDataInfo()

  if (normalDetail.value != null && normalDetail.value.length > 0) {
    if (normalDetail.value.length > 0) {
          const result = normalDetail.value.map((item, i) => ({
            ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
            channel:'normal', // เพิ่ม channel เข้าไป
          }));
          tranlist.value.push(...result);      
    }    
    
  }
  if(migrationDetail.value != null && migrationDetail.value.length > 0){
    if (migrationDetail.value.length > 0) {
          const result = migrationDetail.value.map((item, i) => ({
            ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
            channel: 'migration', // เพิ่ม channel เข้าไป
            type: item.migrationType,
          }));
          tranlist.value.push(...result);      
    } 
  }

  if (outageDetail.value != null && outageDetail.value.length > 0) {
    if (outageDetail.value.length > 0) {
            const result = outageDetail.value.map((item, i) => ({
              ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
              channel:'outage', // เพิ่ม channel เข้าไป
            }));
            tranlist.value.push(...result);      
    }   
  }

 if (outageMigrationDetail.value != null && outageMigrationDetail.value.length > 0) {
    if (outageMigrationDetail.value.length > 0) {
            const result = outageMigrationDetail.value.map((item, i) => ({
              ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
              channel:'outage-migration', // เพิ่ม channel เข้าไป
              type: item.migrationType,
            }));
            tranlist.value.push(...result);      
    }   
  }


  if(lineDetail.value != null && lineDetail.value.length > 0){
    if (lineDetail.value.length > 0) {
            const result = lineDetail.value.map((item, i) => ({
              ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
              channel:'line', // เพิ่ม channel เข้าไป
            }));
            tranlist.value.push(...result);      
    } 
  }
  if (tranlist.value && tranlist.value.length > 0) {
      // 1. กำหนดลำดับ Channel
      const channelOrder = {
        "normal": 1,
        "migration": 2,
        "outage": 3,
        "outage-migration": 4,
        "line": 5
      };

      // 2. กำหนดลำดับ Type
      const typeOrder = {
        "PAWN": 1,
        "INTEREST": 2,
        "INC_PRINCIPLE": 3,
        "DEC_PRINCIPLE": 4,
        "REDEEM": 5
      };

      // 3. Sort ตาม Channel ก่อน แล้วตามด้วย Type
      tranlist.value.sort((a, b) => {
        // เรียงตาม Channel ที่กำหนด
        const orderA = channelOrder[a.channel] || 99;
        const orderB = channelOrder[b.channel] || 99;
        
        if (orderA !== orderB) {
          return orderA - orderB;
        }

        // ถ้า Channel เดียวกัน ให้เรียงตาม Type
        const tOrderA = typeOrder[a.type] || 99;
        const tOrderB = typeOrder[b.type] || 99;
        return tOrderA - tOrderB;
      });

      // 4. ทำ Grouping Flag ตาม channel
      tranlist.value = tranlist.value.map((item, index, array) => {
        return {
          ...item,
          isFirstInGroup: index === 0 || item.channel !== array[index - 1].channel,
          isLastInGroup: index === array.length - 1 || item.channel !== array[index + 1].channel
        };
      });
  }

  // console.log('tranlist : ' + JSON.stringify(tranlist.value))
}

async function getNormalInfo() {
  let data = "";
  data = {
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getNormalFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        normalDetail.value = response.data.data;
      }
    }
  }
}

async function getMigrationInfo() {
  let data = "";
  data = {
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getMigrationFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
         migrationDetail.value = response.data.data;
      }
    }
  }
}

async function getOutageInfo() {
  let data = "";
  data = {
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getOutageFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          outageDetail.value = response.data.data;
      }
    }
  }
}

async function getOutageMigrationInfo() {
  let data = "";
  data = {
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getOutageMigrationFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          outageMigrationDetail.value = response.data.data;
      }
    }
  }
}

async function getLineInfo() {
  let data = "";
  data = {
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getLineFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
         lineDetail.value = response.data.data;
      }
    }
  }
}

async function getSummaryInfo() {
  let data = "";
  data = {
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getSummaryFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          summaryDetail.value = response.data.data;
      }
    }
  }
}

async function getGraphDataInfo() {
  let data = "";
  data = {
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getGraphDataFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        const result = fillEvery30Minutes(response.data.data);
        graphDataDetail.value = result;
        //console.log(result);
      }
    }
  }
}


async function getCatDetailInfo(item) {
  let data = "";
  data = {
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
    type: item.type,
    migrationType: item.migrationType,
  };
  
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  let response = null

  if (item.channel === 'normal') {
    response = await storetr.getNormalCatDetailFetch(payload);
  }else if (item.channel === 'migration') {
    response = await storetr.getMigrationCatDetailFetch(payload);
  }else if (item.channel === 'outage') {
    response = await storetr.getOutageCatDetailFetch(payload);
  }else if (item.channel === 'outage-migration') {
    response = await storetr.getOutageMigrationCatDetailFetch(payload);
  }else if (item.channel === 'line') {
    response = await storetr.getLineCatDetailFetch(payload);
  }
  // console.log('cat r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // 1. ปรับการแมปข้อมูลโดยกำหนด width เป็น % หรือ px
        const items1 = response.data.data.map(item => `
            <div style="display: flex;">
                <span style="width: 35%;">${item.catName}</span>
                <span style="width: 20%;color: #777;">จำนวน</span>
                <span style="width: 20%;color: blue;">
                    <b>${item.amount}</b>
                </span>
                <span style="width: 10%;color: #777;">รายการ</span>
            </div>
        `);

        // 2. เรียกใช้ swal
        swal({
          title: 'ข้อมูลรายละเอียดทรัพย์',
          width: 700,
          html: items1.length > 0 
            ? `<ol style="text-align: left; line-height: 1.8;">${items1.map(text => `<li>${text}</li>`).join('')}</ol>`
            : '<p style="color: #888;">ไม่พบข้อมูลรายละเอียดทรัพย์</p>',
        });
      }
    }
  }
}


function fillEvery30Minutes(data) {
    const fullData = [...data];
    const existingTimes = new Set(data.map(item => item.time));

    // 1. กำหนดลำดับความสำคัญของ Type
    const typeOrder = {
        "PAWN": 1,
        "INTEREST": 2,
        "INC_PRINCIPLE": 3,
        "DEC_PRINCIPLE": 4,
        "REDEEM": 5
    };

    // 2. เติมเวลาที่ขาดหายไป (00:00 - 23:30)
    for (let h = 0; h < 24; h++) {
        [0, 30].forEach(m => {
            const timeSlot = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00`;
            
            if (!existingTimes.has(timeSlot)) {
                fullData.push({
                    time: timeSlot,
                    type: "", // หรือใส่ Default Type ที่ต้องการ
                    total: 0,
                    pawnValue: 0,
                    idNoOtp: 0,
                    idOtp: 0,
                    noIdNoOtp: 0,
                    noIdOtp: 0,
                    shopRepresent: 0
                });
            }
        });
    }

    // 3. Sort ตามเวลา และตาม Type ที่กำหนด
    return fullData.sort((a, b) => {
        // เรียงตามเวลาก่อน
        const timeCompare = a.time.localeCompare(b.time);
        if (timeCompare !== 0) return timeCompare;

        // ถ้าเวลาเดียวกัน ให้เรียงตาม Type Order (ถ้าไม่มีใน list ให้ไปอยู่ท้ายสุด)
        const orderA = typeOrder[a.type] || 99;
        const orderB = typeOrder[b.type] || 99;
        return orderA - orderB;
    });
}



onMounted(() => {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
});

</script>

<style lang="scss" scoped>
.grid-container {
  max-width: 990px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.btnClose {
  border-color: transparent !important;
  background-color: white !important;
  vertical-align: baseline;

  i.material-icons {
    padding-top: 8px;
    color: gray-600;
  }
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.left {
  display: flex;
  justify-content: flex-end;
  margin-right: auto;
  margin-left: 0;
}

/* นำ Font Awesome มาใช้สำหรับไอคอน */
@import url('https://cdnjs.cloudflare.com');
@import url('https://fonts.googleapis.com');



.dashboard-container {
  display: flex;
  gap: 16px;
  padding: 20px;
  flex-wrap: wrap;
  font-family: 'Sarabun', sans-serif; /* แนะนำให้ใช้ฟอนต์ไทย */
}


.dashboard-containerd {
  display: flex;
  gap: 16px;
  padding: 20px;
  flex-wrap: wrap;
  font-family: 'Sarabun', sans-serif; /* แนะนำให้ใช้ฟอนต์ไทย */
}


.card-d {
  background: #fff;
  border-radius: 12px;
  padding: 16px 24px;
  min-width: 280px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  border: 2px solid #eee;
  flex: 1;
}


.icon-section {
  font-size: 42px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  opacity: 0.7;
}

.data-section {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 1.25rem;
  font-weight: 600;
  color: #3f516f;
  margin-bottom: 4px;
}

.value {
  font-size: 1.4rem;
  font-weight: 800;
  margin-bottom: 2px;
}

.unit {
  font-size: 0.9rem;
  font-weight: normal;
  margin-left: 4px;
}

.sub-text {
  font-size: 0.9rem;
  color: #666;
}


/* สีแยกตามสถานะ */
.pawn-in { border-color: #bae6fd; }
.pawn-in .value { color: #0369a1; }
.pawn-in .icon-section { color: #0ea5e9; }

.pawn-out { border-color: #fed7aa; }
.pawn-out .value { color: #c2410c; }
.pawn-out .icon-section { color: #f97316; }

.interest { border-color: #fef08a; }
.interest .value { color: #a16207; }
.interest .icon-section { color: #eab308; }

.net-cash { border-color: #bbf7d0; }
.net-cash .icon-section { color: #22c55e; }

/* Responsive */
@media (max-width: 768px) {
  .card {
    min-width: 100%;
  }
}
/* สีเขียวเมื่อค่าเป็นบวก (>= 0) */
.text-success {
  color: #15803d !important;
  font-weight: bold;
}

/* สีแดงเมื่อค่าติดลบ (< 0) */
.text-danger {
  color: #e53e3e !important;
  font-weight: bold;
}

/* คอนเทนเนอร์หลัก */
.summary-row {
  width: 100%;
}

.summary-card {
  flex: 1; /* ให้แต่ละกล่องกว้างเท่ากัน */
  padding: 12px 20px;
  border-radius: 10px;
  //border-left: 5px solid; /* เส้นหนาด้านซ้ายเพื่อความสวยงาม */
  border: 5px solid;
  transition: transform 0.2s;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
}

.label {
  font-size: 0.9rem;
  color: #5c6b7a;
  font-weight: 500;
}

.value {
  font-size: 1.25rem;
  font-weight: 800;
  margin-left: 15px;
}

/* --- การกำหนดสีตามประเภท --- */

/* สีน้ำเงิน - จำนวนตั๋ว */
.color-blue {
  background-color: #f0f7ff;
  // border-left-color: #4A90E2;
  border-color: #4A90E2;
}
.color-blue .value { color: #4A90E2; }

/* สีเขียว - จำนวนลูกค้า */
.color-green {
  background-color: #f2faf3;
  // border-left-color: #66BB6A;
  border-color: #66BB6A;
}
.color-green .value { color: #66BB6A; }

/* สีแดง/ชมพู - ผู้มีอำนาจ */
.color-red {
  background-color: #fff5f5;
  // border-left-color: #EF5350;
  border-color: #EF5350;
}
.color-red .value { color: #EF5350; }

/* ป้องกันตัวอักษรตกบรรทัดในจอเล็ก */
@media (max-width: 991px) {
  .d-flex {
    flex-direction: column;
  }
  .summary-card {
    width: 100%;
  }
}

/* เส้นขอบหนาด้านบน เมื่อเริ่มกลุ่มใหม่ */
.group-start {
  border-top: 2px solid #444 !important;
}

/* เส้นขอบหนาด้านล่าง เมื่อจบกลุ่ม (หรือจบตาราง) */
.group-end {
  border-bottom: 2px solid #444 !important;
}

/* ตกแต่งคอลัมน์ Channel ให้ดูเป็นระเบียบ */
.channel-cell {
  background-color: #fcfcfc;
  border-right: 1px solid #dee2e6;
  vertical-align: middle; /* ให้ชื่อกลุ่มอยู่กึ่งกลางแนวตั้ง */
}

/* เส้นแบ่งคอลัมน์แนวตั้งให้ชัดเจน */
.border-left {
  border-left: 1px solid #dee2e6;
}

</style>
